var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCourse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-learning:not(.animated) .animable {opacity: 0;}svg#freepik_stories-learning.animated #freepik--Elements--inject-7 {animation: 1.5s Infinite  linear wind;animation-delay: 0s;}            @keyframes wind {                0% {                    transform: rotate( 0deg );                }                25% {                    transform: rotate( 1deg );                }                75% {                    transform: rotate( -1deg );                }            }")), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "251.785px 251.896px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M438,373.56c4.38-2.26,9.53-2.55,14.39-1.75,2.61.43,5.33,1.21,7.11,3.18s2.11,5.41.08,7.09a6.78,6.78,0,0,1-4.49,1.14c-3.8,0-8-.71-11.06,1.58-1.74,1.3-2.89,3.47-5,4.11a4.9,4.9,0,0,1-5.39-2.39,8.43,8.43,0,0,1-.61-6.19A9.45,9.45,0,0,1,438,373.56Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "446.838px 380.221px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M428,354.2c2.68,3.82,7.88,2.56,10.29.22s3.43-5.71,4.36-8.94c2.12-7.37,4.26-15.1,2.68-22.6a12.61,12.61,0,0,0-2.88-6.15,6.59,6.59,0,0,0-6.22-2.07c-2.62.7-4.25,3.26-5.43,5.71a53.83,53.83,0,0,0-5.33,23.12c0,3.73.43,7.63,2.53,10.71",
    fill: "#ebebeb",
    style: {
      transformOrigin: "435.673px 335.583px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M420.65,359.68c2.91-3.44,3.46-8.48,2.16-12.8s-4.21-8-7.58-11a41.08,41.08,0,0,0-13.58-8,14.41,14.41,0,0,0-6.1-1,6.39,6.39,0,0,0-5.13,3.1c-1.43,2.72-.06,6,1.43,8.72a103.43,103.43,0,0,0,8.91,13.58c2.68,3.45,5.74,6.85,9.81,8.41S418.88,362,421,359.2",
    fill: "#ebebeb",
    style: {
      transformOrigin: "406.646px 344.253px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M427.82,411.87a8.35,8.35,0,0,0,.24-1.74c.12-1.26.28-2.85.46-4.74a66.67,66.67,0,0,1,1.07-6.95,53.66,53.66,0,0,1,2.53-8.21,30.24,30.24,0,0,1,4.19-7.43,15.66,15.66,0,0,1,5.3-4.4,14.72,14.72,0,0,1,4.46-1.39,8,8,0,0,0,1.73-.25,8,8,0,0,0-1.76,0,13.55,13.55,0,0,0-4.65,1.21,15.53,15.53,0,0,0-5.59,4.45,29.36,29.36,0,0,0-4.35,7.57,50.64,50.64,0,0,0-2.51,8.34,58.8,58.8,0,0,0-.92,7.05c-.15,2-.21,3.64-.24,4.77A8.26,8.26,0,0,0,427.82,411.87Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "437.776px 394.291px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M428.15,408.22a3.57,3.57,0,0,0,0-.8v-2.31c0-2,0-4.89.1-8.47.18-7.15.79-14.84,2-25.69,1.13-10.2,2.64-22.07,4.23-29.79.34-1.76.69-3.34,1-4.72s.58-2.58.83-3.55l.54-2.24a3.3,3.3,0,0,0,.14-.8,4.07,4.07,0,0,0-.28.76c-.18.58-.4,1.31-.67,2.21s-.6,2.14-.95,3.53-.74,2.95-1.11,4.7a261.33,261.33,0,0,0-4.45,27.64c-1.19,10.88-1.73,20.77-1.78,27.94,0,3.59,0,6.49.13,8.49,0,.94.1,1.7.14,2.3A3,3,0,0,0,428.15,408.22Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "432.37px 369.035px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M428.19,389.13a15.9,15.9,0,0,0,0-2.41c-.09-1.54-.31-3.78-.74-6.52a86.25,86.25,0,0,0-2.12-9.5,78.09,78.09,0,0,0-4-11.25,59.75,59.75,0,0,0-11.67-18.18,28.17,28.17,0,0,0-2.75-2.55c-.42-.36-.79-.71-1.17-1l-1.06-.74a16.47,16.47,0,0,0-2-1.3c-.12.16,2.87,1.92,6.64,5.93a63.21,63.21,0,0,1,11.38,18.11,87.62,87.62,0,0,1,4,11.15,96.12,96.12,0,0,1,2.26,9.41c.5,2.71.78,4.92,1,6.46A15.46,15.46,0,0,0,428.19,389.13Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "415.456px 362.405px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "409.74 422.81 411.65 449.02 445.32 449.02 447.24 422.81",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "428.49px 435.915px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 406.49,
    y: 412.48,
    width: 44.76,
    height: 10.33,
    fill: "#e0e0e0",
    style: {
      transformOrigin: "428.87px 417.645px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "406.49 448.01 406.49 450.88 408.59 450.88 450.51 450.88 450.51 448.01",
    fill: "#ebebeb",
    style: {
      transformOrigin: "428.5px 449.445px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "410.65 455.92 408.59 450.88 448.91 450.88 446.5 455.92",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "428.75px 453.4px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M446.61,431.37s-.05.09-.16.25l-.5.66c-.48.61-1.13,1.46-2,2.51l-.09.11-.08-.11L439,428.12h.28l-4.75,6.72-.15.21-.16-.2-5.63-6.69h.32c-.09.13-.2.26-.31.39l-5,6.31-.16.21-.16-.22c-1.71-2.41-3.3-4.67-4.74-6.71h.27l-5.84,6.66-.11.12-.08-.14-1.83-3.07-.47-.82a1.56,1.56,0,0,1-.14-.29s.07.08.2.26l.51.79c.47.73,1.12,1.74,1.93,3l-.19,0,5.76-6.74.14-.17.13.18,4.79,6.69h-.32l5-6.32.31-.39.16-.2.16.2,5.61,6.71h-.31l4.79-6.68.14-.2.14.2,4.71,6.73h-.17l2-2.45.55-.63A1.32,1.32,0,0,1,446.61,431.37Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "428.475px 431.385px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M447.7,422.64c0,.11-8.43.21-18.84.21s-18.84-.1-18.84-.21,8.44-.21,18.84-.21S447.7,422.52,447.7,422.64Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "428.86px 422.64px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M449.4,451.16c0,.12-9.16.21-20.47.21s-20.48-.09-20.48-.21,9.17-.21,20.48-.21S449.4,451,449.4,451.16Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "428.925px 451.16px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 396.45,
    y: 71.73,
    width: 68.19,
    height: 71.08,
    fill: "#e0e0e0",
    style: {
      transformOrigin: "430.545px 107.27px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 391.83,
    y: 71.73,
    width: 68.19,
    height: 71.08,
    fill: "#fafafa",
    style: {
      transformOrigin: "425.925px 107.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M460,142.84H391.81V71.71H460Zm-68.19-.05H460v-71H391.85Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "425.905px 107.275px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 401,
    y: 81.29,
    width: 49.86,
    height: 51.97,
    fill: "#fafafa",
    style: {
      transformOrigin: "425.93px 107.275px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M401,133.6a8.29,8.29,0,0,1-1.23,1.43c-.8.84-1.92,2-3.17,3.22s-2.41,2.33-3.26,3.12a8.33,8.33,0,0,1-1.44,1.2,7.91,7.91,0,0,1,1.22-1.43c.8-.84,1.92-2,3.18-3.22s2.41-2.34,3.26-3.12A8.33,8.33,0,0,1,401,133.6Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "396.45px 138.085px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M450.86,133.48a8.16,8.16,0,0,1,1.43,1.23c.84.79,2,1.91,3.21,3.17s2.34,2.4,3.12,3.25a8.33,8.33,0,0,1,1.2,1.44,7,7,0,0,1-1.43-1.22c-.84-.8-2-1.92-3.22-3.18s-2.34-2.41-3.12-3.26A7.58,7.58,0,0,1,450.86,133.48Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "455.34px 138.025px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M450.72,81.42A8.16,8.16,0,0,1,452,80c.8-.84,1.92-2,3.17-3.21s2.41-2.34,3.26-3.12a7.91,7.91,0,0,1,1.44-1.2,7.76,7.76,0,0,1-1.23,1.43c-.79.84-1.91,2-3.17,3.22s-2.42,2.34-3.27,3.12A7.58,7.58,0,0,1,450.72,81.42Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "455.295px 76.945px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M400.86,81.55a7.76,7.76,0,0,1-1.43-1.23c-.84-.79-2-1.91-3.21-3.17s-2.34-2.41-3.12-3.26a7.91,7.91,0,0,1-1.2-1.44,8.37,8.37,0,0,1,1.42,1.23c.84.79,2,1.92,3.22,3.17s2.35,2.42,3.13,3.27A7.58,7.58,0,0,1,400.86,81.55Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "396.38px 77px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m450.72 133.26s0-0.09 0-0.25 0-0.42 0-0.73v-2.81c0-2.46 0-6-0.05-10.59 0-9.1-0.06-22.07-0.1-37.59l0.19 0.19h-49.72l0.22-0.22v52l-0.19-0.19 36 0.1 10.11 0.05h2.68-2.64-10.07l-36.12 0.1h-0.19v-0.19-52-0.23h0.16 49.72 0.19v0.2c0 15.57-0.07 28.58-0.1 37.72 0 4.53 0 8.09-0.05 10.54v2.77 0.71a2.07 2.07 0 0 1-0.04 0.42z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "425.875px 107.11px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 417.61,
    y: 98.95,
    width: 16.64,
    height: 16.64,
    fill: "#ebebeb",
    style: {
      transformOrigin: "425.93px 107.27px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 396.45,
    y: 159.67,
    width: 68.19,
    height: 71.08,
    fill: "#e0e0e0",
    style: {
      transformOrigin: "430.545px 195.21px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 391.83,
    y: 159.67,
    width: 68.19,
    height: 71.08,
    fill: "#fafafa",
    style: {
      transformOrigin: "425.925px 195.21px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M460,230.78H391.81V159.65H460Zm-68.19-.05H460v-71H391.85Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "425.905px 195.215px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 401,
    y: 169.23,
    width: 49.86,
    height: 51.97,
    fill: "#fafafa",
    style: {
      transformOrigin: "425.93px 195.215px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M401,221.55a8.76,8.76,0,0,1-1.23,1.43c-.8.84-1.92,2-3.17,3.21s-2.41,2.34-3.26,3.12a8.33,8.33,0,0,1-1.44,1.2,7.91,7.91,0,0,1,1.22-1.43c.8-.84,1.92-2,3.18-3.22s2.41-2.34,3.26-3.12A7.42,7.42,0,0,1,401,221.55Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "396.45px 226.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M450.86,221.42a8.16,8.16,0,0,1,1.43,1.23c.84.79,2,1.91,3.21,3.17s2.34,2.4,3.12,3.25a7.74,7.74,0,0,1,1.2,1.45,7.76,7.76,0,0,1-1.43-1.23c-.84-.79-2-1.92-3.22-3.17s-2.34-2.42-3.12-3.27A7.58,7.58,0,0,1,450.86,221.42Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "455.34px 225.97px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m450.72 169.37a7.59 7.59 0 0 1 1.23-1.44c0.8-0.84 1.92-2 3.17-3.21s2.41-2.33 3.26-3.12a7.91 7.91 0 0 1 1.44-1.2 7.76 7.76 0 0 1-1.23 1.43c-0.79 0.84-1.91 2-3.17 3.22s-2.42 2.34-3.27 3.12a8.54 8.54 0 0 1-1.43 1.2z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "455.27px 164.885px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M400.86,169.49a7.76,7.76,0,0,1-1.43-1.23c-.84-.79-2-1.91-3.21-3.17s-2.34-2.4-3.12-3.25a8.33,8.33,0,0,1-1.2-1.44,7.46,7.46,0,0,1,1.42,1.22c.84.79,2,1.92,3.22,3.17s2.35,2.42,3.13,3.27A7.58,7.58,0,0,1,400.86,169.49Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "396.38px 164.945px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m450.72 221.2s0-0.09 0-0.25 0-0.42 0-0.73v-2.8c0-2.47 0-6-0.05-10.6 0-9.1-0.06-22.07-0.1-37.59l0.19 0.19h-49.72l0.22-0.22v52l-0.26-0.2 36 0.1h10.11 2.68-2.64-10.07l-36.12 0.1h-0.19v-0.19-52-0.01h0.23 49.72 0.19v0.2c0 15.57-0.07 28.58-0.1 37.72 0 4.53 0 8.09-0.05 10.55v2.76 0.71a1.85 1.85 0 0 1-0.04 0.26z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "425.84px 195.1px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 417.61,
    y: 186.89,
    width: 16.64,
    height: 16.64,
    fill: "#ebebeb",
    style: {
      transformOrigin: "425.93px 195.21px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M249,120l.59,1a6.79,6.79,0,0,0,2.78,2.56l1,.5-1,.6a6.67,6.67,0,0,0-2.56,2.78l-.51,1-.59-1a6.73,6.73,0,0,0-2.78-2.56l-1-.51,1-.59a6.73,6.73,0,0,0,2.56-2.78Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "249.15px 124.22px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M354.39,92.41l.59,1A6.67,6.67,0,0,0,357.76,96l1,.51-1,.59a6.73,6.73,0,0,0-2.56,2.78l-.51,1-.59-1a6.79,6.79,0,0,0-2.78-2.56l-1-.51,1-.59a6.73,6.73,0,0,0,2.56-2.78Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "354.54px 96.645px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M300.69,59l.3.49a3.36,3.36,0,0,0,1.39,1.28l.52.26-.49.29a3.35,3.35,0,0,0-1.29,1.4l-.25.51-.3-.49a3.3,3.3,0,0,0-1.39-1.28l-.52-.26.5-.3a3.37,3.37,0,0,0,1.28-1.39Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "300.78px 61.115px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M341.49,92.78l.29.49a3.39,3.39,0,0,0,1.4,1.28l.51.26-.49.29a3.39,3.39,0,0,0-1.28,1.4l-.26.51-.29-.49a3.39,3.39,0,0,0-1.4-1.28l-.51-.26.49-.29a3.39,3.39,0,0,0,1.28-1.4Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "341.575px 94.895px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M302.81,128.84l.3.49a3.37,3.37,0,0,0,1.39,1.28l.52.26-.5.29a3.39,3.39,0,0,0-1.28,1.4l-.26.51-.29-.49a3.45,3.45,0,0,0-1.39-1.29l-.52-.25.49-.3a3.39,3.39,0,0,0,1.29-1.39Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "302.9px 130.955px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M349.94,158.79c.36-2.63-3.36-4.8-6.16-5a16,16,0,0,1-4-.34c-2.74-1-3.83-4.49-6.5-5.62-2-.84-4.3-.09-6.24.88s-3.85,2.2-6,2.34c-1.88.12-3.93-.58-5.57.34-1.23.69-1.87,2.1-3,2.94a7.26,7.26,0,0,1-3.92,1.06,11,11,0,0,0-4.05.66,3.18,3.18,0,0,0-2,3.24Z",
    fill: "#ebebeb",
    style: {
      transformOrigin: "326.226px 153.378px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M264.69,63.46c.5-3.62-4.61-6.6-8.44-6.9-1.84-.15-3.74.13-5.47-.48-3.76-1.31-5.26-6.16-8.92-7.71-2.74-1.15-5.9-.12-8.56,1.21s-5.28,3-8.25,3.21c-2.58.17-5.38-.79-7.64.47-1.69.94-2.57,2.88-4.12,4a9.89,9.89,0,0,1-5.38,1.46,15.25,15.25,0,0,0-5.55.9c-1.71.79-3.13,2.6-2.78,4.45Z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "232.125px 55.9714px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 42.78,
    y: 53.44,
    width: 115.73,
    height: 191.56,
    fill: "#e0e0e0",
    style: {
      transformOrigin: "100.645px 149.22px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 38.93,
    y: 53.44,
    width: 115.73,
    height: 191.56,
    fill: "#ebebeb",
    style: {
      transformOrigin: "96.795px 149.22px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 43.86,
    y: 57.32,
    width: 105.87,
    height: 183.79,
    fill: "#fafafa",
    style: {
      transformOrigin: "96.795px 149.215px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "animable",
    x: 64.02,
    y: 81.2,
    width: 65.1,
    height: 136.03,
    fill: "#ebebeb",
    style: {
      transformOrigin: "96.57px 149.215px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M64,169.1c-.15-12.71,11.27-25.12,23.86-26.89,6-.85,12.37.35,18-2,10-4.11,13.19-17.4,23.26-21.35l.46,98.32H64Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "96.7893px 168.02px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "242.31px 202.407px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M81.9,115.94a1.1,1.1,0,0,1,.09.27l.22.8a11.55,11.55,0,0,0,.41,1.3c.18.5.37,1.09.66,1.72l.44,1,.57,1.08a10.52,10.52,0,0,0,.66,1.15c.25.38.47.8.77,1.2a25.89,25.89,0,0,0,11.33,9.25,24.34,24.34,0,0,0,4.31,1.35,41.49,41.49,0,0,0,4.75.66c3.27.32,6.81.5,10.2,1.86a24.81,24.81,0,0,1,8.88,6.65,32.28,32.28,0,0,1,6.12,9.28,17.22,17.22,0,0,1,1.22,5.18,19.44,19.44,0,0,1-.32,5.08,61.35,61.35,0,0,1-2.7,9,42.43,42.43,0,0,0-2.14,7.84,16.29,16.29,0,0,0,.25,6.64,12.37,12.37,0,0,0,2.17,4.52,9.1,9.1,0,0,0,2.34,2.16c.61.39,1,.54,1,.56a6.46,6.46,0,0,1-1-.5,9,9,0,0,1-2.4-2.14,12.24,12.24,0,0,1-2.25-4.55,16.48,16.48,0,0,1-.31-6.73,43.32,43.32,0,0,1,2.12-7.89,62.71,62.71,0,0,0,2.66-9,19.85,19.85,0,0,0,.3-5,16.6,16.6,0,0,0-1.21-5.07,32.2,32.2,0,0,0-6.06-9.19,24.5,24.5,0,0,0-8.76-6.56c-3.31-1.35-6.82-1.53-10.1-1.86a45.07,45.07,0,0,1-4.78-.68A24.67,24.67,0,0,1,96.94,134a25.78,25.78,0,0,1-11.37-9.41c-.3-.4-.53-.82-.77-1.21a12.55,12.55,0,0,1-.65-1.17l-.56-1.08-.43-1a16,16,0,0,1-.64-1.74,11,11,0,0,1-.37-1.31c-.08-.35-.15-.62-.19-.81A2.22,2.22,0,0,1,81.9,115.94Z",
    fill: "#455a64",
    style: {
      transformOrigin: "107.515px 155.215px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M102.23,105.34l.22.2.62.6c.27.27.57.63,1,1s.76.92,1.16,1.52a21.48,21.48,0,0,1,2.47,4.64,22.28,22.28,0,0,1,1.51,6.79,23.26,23.26,0,0,1-.15,4.05,29.17,29.17,0,0,1-.94,4.3c-.83,2.92-2,5.92-2.88,9.21a23.42,23.42,0,0,0-.73,5.13,21.88,21.88,0,0,0,.55,5.37A25,25,0,0,0,110,158.35a28.38,28.38,0,0,0,8.77,7.16,34.07,34.07,0,0,0,10,3.48c3.34.62,6.58.78,9.58,1.24a24.17,24.17,0,0,1,8.06,2.44,18.4,18.4,0,0,1,8,9,18.37,18.37,0,0,1,1,3.17c.06.37.1.65.14.86a2.08,2.08,0,0,1,0,.29s0-.1-.07-.29-.1-.48-.17-.84a20.09,20.09,0,0,0-1-3.14,18.89,18.89,0,0,0-2.73-4.43,18,18,0,0,0-5.3-4.36,24,24,0,0,0-8-2.37c-3-.45-6.23-.6-9.6-1.21a34.81,34.81,0,0,1-10.1-3.5,28.74,28.74,0,0,1-8.88-7.24,25.62,25.62,0,0,1-5-10.29,23.07,23.07,0,0,1-.54-5.45,23.8,23.8,0,0,1,.74-5.2c.85-3.32,2.08-6.32,2.92-9.22a28.9,28.9,0,0,0,1-4.25,21.94,21.94,0,0,0,.17-4,22.46,22.46,0,0,0-3.85-11.36c-.39-.61-.8-1.09-1.13-1.54s-.66-.78-.92-1l-.59-.63A2.35,2.35,0,0,1,102.23,105.34Z",
    fill: "#455a64",
    style: {
      transformOrigin: "128.893px 145.665px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M151.92,177a5.38,5.38,0,0,1-.78.71c-.52.45-1.29,1.07-2.26,1.81a90.21,90.21,0,0,1-7.84,5.42,92.36,92.36,0,0,1-8.37,4.57c-1.1.53-2,.94-2.62,1.2a5,5,0,0,1-1,.38,7.45,7.45,0,0,1,.93-.5l2.58-1.29c2.17-1.1,5.13-2.7,8.29-4.65s5.92-3.88,7.88-5.32l2.31-1.72A6.84,6.84,0,0,1,151.92,177Z",
    fill: "#455a64",
    style: {
      transformOrigin: "140.485px 184.045px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M146.55,172.8a4.57,4.57,0,0,1-.79.47l-2.18,1.18c-1.84,1-4.36,2.42-7.09,4.09s-5.13,3.29-6.85,4.48l-2,1.42a6.23,6.23,0,0,1-.77.49,4.86,4.86,0,0,1,.69-.6c.46-.37,1.14-.88,2-1.5,1.69-1.25,4.09-2.89,6.82-4.57s5.28-3.07,7.15-4c.94-.48,1.7-.85,2.24-1.09A5.34,5.34,0,0,1,146.55,172.8Z",
    fill: "#455a64",
    style: {
      transformOrigin: "136.71px 178.865px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m138.85 171.18a11 11 0 0 1-1.55 1.13c-1 0.65-2.35 1.53-3.89 2.46s-2.95 1.72-4 2.28a10.89 10.89 0 0 1-1.72 0.83 11.48 11.48 0 0 1 1.6-1l3.94-2.36 3.94-2.37a10.57 10.57 0 0 1 1.68-0.97z",
    fill: "#455a64",
    style: {
      transformOrigin: "133.27px 174.53px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M131.67,162.68a6.34,6.34,0,0,1-1.17.85l-2.89,1.94-2.87,2a6.63,6.63,0,0,1-1.22.77,5.32,5.32,0,0,1,1.08-1c.7-.56,1.69-1.29,2.82-2.06s2.18-1.42,3-1.86A5.49,5.49,0,0,1,131.67,162.68Z",
    fill: "#455a64",
    style: {
      transformOrigin: "127.595px 165.46px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M131.1,155.1c0,.05-.85.51-2.22,1.3s-3.24,1.94-5.21,3.32-3.69,2.76-4.9,3.78a24.83,24.83,0,0,1-2,1.64,3.62,3.62,0,0,1,.46-.52c.31-.32.78-.76,1.37-1.3a50.95,50.95,0,0,1,10.15-7.13c.7-.37,1.28-.65,1.68-.84A2.71,2.71,0,0,1,131.1,155.1Z",
    fill: "#455a64",
    style: {
      transformOrigin: "123.935px 160.12px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m127.35 149.22c0.05 0.08-3.46 2.61-7.84 5.67s-8 5.46-8 5.39 3.45-2.62 7.83-5.67 7.95-5.47 8.01-5.39z",
    fill: "#455a64",
    style: {
      transformOrigin: "119.43px 154.75px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M124.36,142.59a3.93,3.93,0,0,1-.68.5c-.5.34-1.13.77-1.89,1.27-1.6,1.07-3.8,2.57-6.19,4.27s-4.51,3.3-6,4.46l-1.82,1.38a4,4,0,0,1-.69.47,3.63,3.63,0,0,1,.61-.58c.4-.35,1-.85,1.75-1.46,1.5-1.21,3.6-2.84,6-4.54s4.62-3.18,6.25-4.2c.82-.51,1.49-.91,2-1.18A3.74,3.74,0,0,1,124.36,142.59Z",
    fill: "#455a64",
    style: {
      transformOrigin: "115.725px 148.765px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m118.19 138.92c0.06 0.07-2.92 2.23-6.64 4.82s-6.79 4.61-6.85 4.54 2.93-2.24 6.65-4.82 6.79-4.62 6.84-4.54z",
    fill: "#455a64",
    style: {
      transformOrigin: "111.445px 143.6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m111.72 135.22a28.31 28.31 0 0 1-3.42 2.95 30.66 30.66 0 0 1-3.63 2.69 30.56 30.56 0 0 1 3.42-3 30.66 30.66 0 0 1 3.63-2.64z",
    fill: "#455a64",
    style: {
      transformOrigin: "108.195px 138.04px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m107.36 125.93a11.1 11.1 0 0 1-1.46 1.35c-0.93 0.79-2.25 1.86-3.75 3s-2.89 2.08-3.92 2.75a10.1 10.1 0 0 1-1.71 1 13 13 0 0 1 1.58-1.21c1-0.72 2.36-1.71 3.85-2.82s2.83-2.15 3.8-2.9a12.43 12.43 0 0 1 1.61-1.17z",
    fill: "#455a64",
    style: {
      transformOrigin: "101.94px 129.98px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M109.24,119.61a4,4,0,0,1-.67.52c-.43.32-1.08.76-1.88,1.29-1.61,1.07-3.87,2.5-6.42,4s-4.92,2.72-6.65,3.58c-.86.43-1.57.77-2.06,1a3.73,3.73,0,0,1-.78.32,4.52,4.52,0,0,1,.72-.43l2-1.09c1.7-.91,4-2.19,6.59-3.67s4.82-2.86,6.46-3.88l1.94-1.2A3.79,3.79,0,0,1,109.24,119.61Z",
    fill: "#455a64",
    style: {
      transformOrigin: "100.01px 124.965px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M106.24,112.86a5.47,5.47,0,0,1-.73.55c-.48.34-1.18.82-2.06,1.41-1.75,1.16-4.19,2.74-6.92,4.43s-5.22,3.17-7,4.21c-.91.52-1.65.94-2.17,1.22a5.77,5.77,0,0,1-.82.4,4.83,4.83,0,0,1,.75-.52l2.12-1.31,7-4.29,7-4.34,2.12-1.32A4.41,4.41,0,0,1,106.24,112.86Z",
    fill: "#455a64",
    style: {
      transformOrigin: "96.39px 118.97px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M369.36,312.21c-.05.05-.79-.69-2.23-1.92-.72-.61-1.61-1.35-2.69-2.14a30.22,30.22,0,0,0-3.84-2.4,16.37,16.37,0,0,0-2.4-1,7.91,7.91,0,0,0-2.7-.48,2.91,2.91,0,0,0-1.31.31,2,2,0,0,0-.9.95,3.3,3.3,0,0,0-.27,1.42,7.1,7.1,0,0,0,.2,1.56,14.86,14.86,0,0,0,1.16,3.13,28.91,28.91,0,0,0,1.77,3.07,42.59,42.59,0,0,0,10.36,10.67,26.58,26.58,0,0,0,3,1.86,14.63,14.63,0,0,0,3.1,1.26,7.05,7.05,0,0,0,1.55.25,3.32,3.32,0,0,0,1.42-.23,2,2,0,0,0,1-.87,3,3,0,0,0,.35-1.3,7.77,7.77,0,0,0-.4-2.72,17.56,17.56,0,0,0-1-2.43,31.14,31.14,0,0,0-2.29-3.91c-.76-1.1-1.46-2-2.06-2.75-1.18-1.47-1.9-2.24-1.85-2.29s.22.15.59.5.88.87,1.51,1.58a34.39,34.39,0,0,1,2.19,2.69,29.05,29.05,0,0,1,2.44,3.92,19.76,19.76,0,0,1,1.05,2.5,8.49,8.49,0,0,1,.47,3,3.55,3.55,0,0,1-.42,1.61,2.69,2.69,0,0,1-1.3,1.19,4.06,4.06,0,0,1-1.74.31,7.77,7.77,0,0,1-1.73-.25,15.7,15.7,0,0,1-3.27-1.3A27.26,27.26,0,0,1,366,326a42.14,42.14,0,0,1-10.57-10.9,27,27,0,0,1-1.81-3.16,15.81,15.81,0,0,1-1.19-3.31,7.24,7.24,0,0,1-.2-1.73,3.84,3.84,0,0,1,.36-1.73,2.71,2.71,0,0,1,1.23-1.27,3.65,3.65,0,0,1,1.62-.37,8.45,8.45,0,0,1,2.94.56,18,18,0,0,1,2.46,1.13,28.72,28.72,0,0,1,3.84,2.55c1.07.84,1.94,1.61,2.63,2.27s1.2,1.19,1.53,1.56S369.38,312.19,369.36,312.21Z",
    fill: "#455a64",
    style: {
      transformOrigin: "364.906px 316.542px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M359.77,314.61c.06,0-.23,1-.61,2.78-.19.9-.4,2-.57,3.28a28,28,0,0,0-.24,4.37,15.73,15.73,0,0,0,.26,2.51,7.48,7.48,0,0,0,.89,2.5,3,3,0,0,0,.9.95,2.12,2.12,0,0,0,1.23.34A3.3,3.3,0,0,0,363,331a6.34,6.34,0,0,0,1.26-.85,14.3,14.3,0,0,0,2.19-2.38,25.35,25.35,0,0,0,1.83-2.89,39.68,39.68,0,0,0,4.35-13.7,26.4,26.4,0,0,0,.17-3.41,14.46,14.46,0,0,0-.41-3.21,7.31,7.31,0,0,0-.54-1.42,3.24,3.24,0,0,0-.88-1.08,2.08,2.08,0,0,0-1.2-.44,3,3,0,0,0-1.28.26,7.57,7.57,0,0,0-2.17,1.52,16.2,16.2,0,0,0-1.66,1.91A27.35,27.35,0,0,0,362.3,309c-.6,1.14-1.06,2.16-1.42,3-.72,1.69-1.05,2.65-1.11,2.63a2.22,2.22,0,0,1,.15-.73c.13-.47.34-1.15.65-2s.74-1.91,1.31-3.09a26.63,26.63,0,0,1,2.27-3.85,14.77,14.77,0,0,1,1.69-2,8,8,0,0,1,2.35-1.71,3.71,3.71,0,0,1,1.57-.33,2.83,2.83,0,0,1,1.62.56,4.06,4.06,0,0,1,1.1,1.31,7.41,7.41,0,0,1,.62,1.58,14.65,14.65,0,0,1,.46,3.38,24.71,24.71,0,0,1-.15,3.53,39,39,0,0,1-4.45,14,25.09,25.09,0,0,1-1.91,3,14.53,14.53,0,0,1-2.33,2.49,7.32,7.32,0,0,1-1.41.93,3.94,3.94,0,0,1-1.66.44,2.86,2.86,0,0,1-1.64-.47,3.84,3.84,0,0,1-1.1-1.18,8.07,8.07,0,0,1-.93-2.75,15,15,0,0,1-.22-2.61,25.66,25.66,0,0,1,.37-4.46,32.73,32.73,0,0,1,.71-3.28c.24-.89.47-1.57.63-2A2.29,2.29,0,0,1,359.77,314.61Z",
    fill: "#455a64",
    style: {
      transformOrigin: "365.665px 316.53px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M363.05,310c0,.07-1,.33-2.69.95-.86.31-1.9.71-3.09,1.24a27.78,27.78,0,0,0-3.84,2.1,14.66,14.66,0,0,0-2,1.54,7.22,7.22,0,0,0-1.65,2.07,3,3,0,0,0-.34,1.26,2.09,2.09,0,0,0,.37,1.23,3.09,3.09,0,0,0,1,.94,6.93,6.93,0,0,0,1.38.63,14.68,14.68,0,0,0,3.18.6,25.9,25.9,0,0,0,3.42,0,37.77,37.77,0,0,0,7.13-1.11,38.29,38.29,0,0,0,6.81-2.4,26.74,26.74,0,0,0,3-1.65,13.71,13.71,0,0,0,2.51-2,6.14,6.14,0,0,0,.92-1.21,3.17,3.17,0,0,0,.46-1.31,2.14,2.14,0,0,0-.25-1.25,3.17,3.17,0,0,0-.9-1,7.41,7.41,0,0,0-2.44-1,16,16,0,0,0-2.49-.41,28,28,0,0,0-4.38,0c-1.29.1-2.4.24-3.31.37-1.8.28-2.79.51-2.81.44a2.43,2.43,0,0,1,.7-.25c.46-.14,1.15-.32,2.06-.51s2-.37,3.32-.51a26.85,26.85,0,0,1,4.47-.1,15.29,15.29,0,0,1,2.59.38,7.74,7.74,0,0,1,2.69,1.1,3.63,3.63,0,0,1,1.11,1.16,2.77,2.77,0,0,1,.37,1.67,3.83,3.83,0,0,1-.53,1.63,7.43,7.43,0,0,1-1,1.35,14.66,14.66,0,0,1-2.64,2.18,26.27,26.27,0,0,1-3.08,1.73,38.44,38.44,0,0,1-7,2.47,37.44,37.44,0,0,1-7.29,1.11,24.35,24.35,0,0,1-3.53-.06,14.43,14.43,0,0,1-3.35-.67,7.17,7.17,0,0,1-1.54-.71,4.1,4.1,0,0,1-1.24-1.18,2.84,2.84,0,0,1-.46-1.64,3.66,3.66,0,0,1,.43-1.56,8,8,0,0,1,1.84-2.24,16.35,16.35,0,0,1,2.11-1.56,26.82,26.82,0,0,1,4-2,33.09,33.09,0,0,1,3.17-1.12c.88-.26,1.58-.43,2.05-.53A2.42,2.42,0,0,1,363.05,310Z",
    fill: "#455a64",
    style: {
      transformOrigin: "364.526px 316.044px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m368.09 315.77a2.68 2.68 0 1 1-3.25-1.95 2.69 2.69 0 0 1 3.25 1.95z",
    fill: "#455a64",
    style: {
      transformOrigin: "365.49px 316.421px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M422.72,269.86l-.3-.14-.87-.44-3.35-1.74-12.31-6.47H406l-37.92,14.49-.34.13.1-.35,1.16-4.19c2.65-9.56,5.16-18.61,7.36-26.57l0-.06,0,0,21-15.74,6-4.44,1.59-1.17.41-.29q.13-.11.15-.09l-.13.11-.4.32-1.56,1.2-5.92,4.51-20.94,15.85.06-.09c-2.2,8-4.69,17-7.33,26.59-.4,1.43-.79,2.86-1.16,4.19l-.24-.22,38-14.39,0,0,.06,0,12.25,6.57,3.31,1.79.86.48Z",
    fill: "#f90",
    style: {
      transformOrigin: "395.23px 249.238px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "372.95 275.1 370.68 275.77 369.95 278.02 368.61 276.07 366.24 276.07 367.68 274.19 366.95 271.94 369.18 272.73 371.09 271.34 371.03 273.71",
    fill: "#f90",
    style: {
      transformOrigin: "369.595px 274.68px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "379.5 243.85 378.07 244.37 377.68 245.85 376.74 244.65 375.21 244.74 376.07 243.47 375.51 242.05 376.98 242.47 378.16 241.5 378.21 243.03",
    fill: "#f90",
    style: {
      transformOrigin: "377.355px 243.675px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "408.21 221.82 407.17 223.39 407.86 225.13 406.05 224.62 404.61 225.82 404.53 223.94 402.95 222.94 404.71 222.29 405.17 220.47 406.34 221.94",
    fill: "#f90",
    style: {
      transformOrigin: "405.58px 223.145px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "425.02 267.88 423.97 269.45 424.67 271.19 422.86 270.68 421.41 271.88 421.34 270 419.75 269 421.51 268.35 421.98 266.53 423.14 268",
    fill: "#f90",
    style: {
      transformOrigin: "422.385px 269.205px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "407.38 260.17 406.71 261.17 407.16 262.28 406 261.95 405.08 262.72 405.04 261.52 404.02 260.88 405.15 260.46 405.44 259.3 406.19 260.25",
    fill: "#f90",
    style: {
      transformOrigin: "405.7px 261.01px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 290.54,
    cy: 98.15,
    r: 19.2,
    fill: "#f90",
    style: {
      transformOrigin: "290.54px 98.15px",
      transform: "rotate(-80.73deg)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "284.87px 104.14px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m288 104.14a3.13 3.13 0 1 1-3.13-3.13 3.13 3.13 0 0 1 3.13 3.13z",
    fill: "#fff",
    style: {
      transformOrigin: "284.87px 104.14px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "281.78px 95.1px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m283.6 95.1a1.82 1.82 0 1 1-1.82-1.82 1.82 1.82 0 0 1 1.82 1.82z",
    fill: "#fff",
    style: {
      transformOrigin: "281.78px 95.1px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M271.91,102.82c.09.33-16.43,16.18-12.17,19.56s22.17-5.29,37.44-17.62,29.21-27.31,25.39-31.27-22.89,7.77-22.89,7.77L302,82.71s11.53-7.4,15.18-4.53-6.75,14.1-21.43,24.82-28.87,18.24-31.07,15.3,8.19-12.73,8.19-12.73Z",
    fill: "#f90",
    style: {
      transformOrigin: "291.123px 97.8948px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "291.123px 97.8948px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M271.91,102.82c.09.33-16.43,16.18-12.17,19.56s22.17-5.29,37.44-17.62,29.21-27.31,25.39-31.27-22.89,7.77-22.89,7.77L302,82.71s11.53-7.4,15.18-4.53-6.75,14.1-21.43,24.82-28.87,18.24-31.07,15.3,8.19-12.73,8.19-12.73Z",
    style: {
      transformOrigin: "291.123px 97.8948px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "276.398px 97.8943px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m280 84.62c0.15 0.19-1.15 1.29-2.62 3.51a17.68 17.68 0 0 0-0.39 19.42c1.39 2.27 2.64 3.43 2.48 3.61s-1.64-0.76-3.35-3a16.68 16.68 0 0 1-2.33-4.37 16.61 16.61 0 0 1 0.24-12 16.59 16.59 0 0 1 2.5-4.27c1.76-2.2 3.34-3.03 3.47-2.9z",
    fill: "#fff",
    style: {
      transformOrigin: "276.398px 97.8943px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m319.58 115.07a11.15 11.15 0 1 1 10.88 11.41 11.15 11.15 0 0 1-10.88-11.41z",
    fill: "#f90",
    style: {
      transformOrigin: "330.727px 115.333px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.4,
    style: {
      transformOrigin: "336.179px 111.111px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m334.36 111.07a1.82 1.82 0 1 1 1.77 1.86 1.81 1.81 0 0 1-1.77-1.86z",
    style: {
      transformOrigin: "336.179px 111.111px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.4,
    style: {
      transformOrigin: "339.06px 115.342px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m338 115.31a1.06 1.06 0 1 1 1 1.09 1.07 1.07 0 0 1-1-1.09z",
    style: {
      transformOrigin: "339.06px 115.342px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.4,
    style: {
      transformOrigin: "336.57px 118.95px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M336.57,118.56a.4.4,0,0,1,.39.4.39.39,0,0,1-.4.38.38.38,0,0,1-.38-.4A.39.39,0,0,1,336.57,118.56Z",
    style: {
      transformOrigin: "336.57px 118.95px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M365.62,198.25c-.1,0-.17-14.12-.17-31.53s.07-31.53.17-31.53.17,14.11.17,31.53S365.71,198.25,365.62,198.25Z",
    fill: "#263238",
    style: {
      transformOrigin: "365.62px 166.72px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M367.5,135.73a28.27,28.27,0,0,1-2.14-3.66l.3,0,0,.08a30.5,30.5,0,0,1-1.83,3.93,26.34,26.34,0,0,1,1.52-4.06l0-.08.14-.32.16.3A26.41,26.41,0,0,1,367.5,135.73Z",
    fill: "#263238",
    style: {
      transformOrigin: "365.665px 133.85px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M365.27,127.74c-.06.07-.58-.27-1-.9s-.52-1.24-.43-1.26.33.5.71,1.08S365.33,127.67,365.27,127.74Z",
    fill: "#263238",
    style: {
      transformOrigin: "364.543px 126.664px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m364.28 129.56a11.75 11.75 0 0 1 0.8-2.25 11.25 11.25 0 0 1 0.92-2.2 6.66 6.66 0 0 1-0.61 2.32 6.57 6.57 0 0 1-1.11 2.13z",
    fill: "#263238",
    style: {
      transformOrigin: "365.14px 127.335px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m361.1 143.49a18.78 18.78 0 0 0 0.58-1.94 19.5 19.5 0 0 0 0-2 2.88 2.88 0 0 1 0.29 2.08 2.85 2.85 0 0 1-0.87 1.86z",
    fill: "#263238",
    style: {
      transformOrigin: "361.574px 141.52px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M361.72,140.86s-.08.27-.48.37a.94.94,0,0,1-.69-.12,1,1,0,0,1-.08-1.56,1,1,0,0,1,.68-.18c.41,0,.55.3.51.32s-.21-.1-.52-.08a.67.67,0,0,0-.68.72.69.69,0,0,0,.75.66C361.52,141,361.68,140.82,361.72,140.86Z",
    fill: "#263238",
    style: {
      transformOrigin: "360.927px 140.308px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m414.71 193.77c0 0.09-12.08 0.17-27 0.17s-27-0.08-27-0.17 12.07-0.17 27-0.17 27 0.08 27 0.17z",
    fill: "#263238",
    style: {
      transformOrigin: "387.71px 193.77px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m415.26 193.7a8.15 8.15 0 0 1-2.26-0.7 8.36 8.36 0 0 1-2.1-1 7.88 7.88 0 0 1 2.22 0.71 8.11 8.11 0 0 1 2.14 0.99z",
    fill: "#263238",
    style: {
      transformOrigin: "413.08px 192.85px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m415.85 193.9a10.91 10.91 0 0 1-3.68 1.29 6.21 6.21 0 0 1 1.79-0.8 5.64 5.64 0 0 1 1.89-0.49z",
    fill: "#263238",
    style: {
      transformOrigin: "414.01px 194.545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M363.08,195.48a1.66,1.66,0,0,1,.7,1.12,2.38,2.38,0,0,1-.11,1.47,1.7,1.7,0,0,1-.54.73.92.92,0,0,1-1,0,1.93,1.93,0,0,1-.78-1.64,1.71,1.71,0,0,1,.6-1.35,1.29,1.29,0,0,1,.95-.31c.24,0,.35.11.34.12s-.13,0-.34,0a1.31,1.31,0,0,0-.79.36,1.49,1.49,0,0,0-.45,1.16,1.68,1.68,0,0,0,.64,1.36.61.61,0,0,0,.66,0,1.43,1.43,0,0,0,.45-.58,2.35,2.35,0,0,0,.16-1.3A4.08,4.08,0,0,0,363.08,195.48Z",
    fill: "#263238",
    style: {
      transformOrigin: "362.598px 197.214px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M407,196.19s.19-.11.45.11a.67.67,0,0,1,.23.54,1.15,1.15,0,0,1-.32.69c-.38.42-1.08.58-1.4,1.09a.9.9,0,0,0,0,.87.85.85,0,0,0,.82.41.81.81,0,0,0,.71-.58.89.89,0,0,0-.17-.86,2.45,2.45,0,0,0-.72-.57,1.07,1.07,0,0,1-.64-.66.89.89,0,0,1,.17-.75,1.12,1.12,0,0,1,.45-.34c.29-.1.46-.08.47-.06s-.16,0-.41.18a1,1,0,0,0-.36.33.68.68,0,0,0-.09.58c.1.43.9.49,1.37,1.1a1.22,1.22,0,0,1,.24,1.16,1.15,1.15,0,0,1-1,.8,1.18,1.18,0,0,1-1.14-.57,1.22,1.22,0,0,1,0-1.2,2,2,0,0,1,.8-.66,3.58,3.58,0,0,0,.69-.44.93.93,0,0,0,.3-.54.58.58,0,0,0-.13-.43C407.2,196.19,407,196.22,407,196.19Z",
    fill: "#263238",
    style: {
      transformOrigin: "406.679px 198.15px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m406.86 194.93a6.61 6.61 0 0 1 0-3 6.61 6.61 0 0 1 0 3z",
    fill: "#263238",
    style: {
      transformOrigin: "406.86px 193.43px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M421.29,193.83a2.43,2.43,0,0,1-.92.14l-1,.06a.36.36,0,0,1-.23,0,.28.28,0,0,1-.12-.3.62.62,0,0,1,.21-.32l.44-.46a1.46,1.46,0,0,0,.55-.95.61.61,0,0,0-.42-.62,1,1,0,0,0-.59.11c-.15.06-.23.1-.25.08s.05-.09.18-.19a1,1,0,0,1,.7-.24.86.86,0,0,1,.69.87,1.72,1.72,0,0,1-.6,1.17l-.46.45c-.08.07-.14.14-.14.17h0v0h.06l1,0A2.7,2.7,0,0,1,421.29,193.83Z",
    fill: "#263238",
    style: {
      transformOrigin: "420.123px 192.594px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m372.8 193.77s0-0.34 0-0.93 0-1.46-0.05-2.47c0-2.1-0.06-5-0.07-8.32l0.16 0.17h-3.13l0.17-0.17v3.47 3.17c0 2 0 3.7-0.05 5.07l-0.1-0.1 2.28 0.05c0.54 0 0.84 0 0.85 0.05a6.16 6.16 0 0 1-0.79 0l-2.34 0.05h-0.1v-0.1-5.07-3.17-3.47l0.17-0.17h3.2v0.16c0 3.39 0 6.34-0.08 8.43v2.44a5.42 5.42 0 0 1-0.12 0.91z",
    fill: "#263238",
    style: {
      transformOrigin: "371.315px 187.82px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m402.65 193.77a1.89 1.89 0 0 1 0-0.36v-1c0-0.9 0-2.12-0.05-3.63 0-3.06-0.06-7.3-0.07-12.11l0.17 0.16h-3.14l0.17-0.16v2.64 2.55 4.71c0 2.9-0.05 5.36-0.06 7.16l-0.09-0.09h2.29 0.62 0.23a5.65 5.65 0 0 1-0.79 0l-2.35 0.05h-0.09v-0.09c0-1.8 0-4.26-0.06-7.16v-4.71-2.55-2.64l0.17-0.17h3.3v0.17c0 4.88 0 9.18-0.07 12.23 0 1.49 0 2.7-0.05 3.59v1s-0.13 0.42-0.13 0.41z",
    fill: "#263238",
    style: {
      transformOrigin: "401.165px 185.07px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m380.35 193.77a2.79 2.79 0 0 1 0-0.44v-1.24c0-1.09 0-2.62-0.05-4.52 0-3.83 0-9.12-0.07-15.09l0.17 0.17h-3.14c0.34-0.34 0.09-0.09 0.17-0.16v3.38 3.25 5.93c0 3.64-0.05 6.64-0.07 8.72l-0.08-0.08h2.31 0.61 0.22-0.19-0.6-2.35-0.08v-0.08c0-2.08 0-5.08-0.06-8.72v-5.93-3.25-3.38c0.08-0.08-0.17 0.16 0.17-0.18h3.3v0.16c0 6-0.05 11.35-0.07 15.21 0 1.88 0 3.4-0.05 4.48v1.2s-0.14 0.58-0.14 0.57z",
    fill: "#263238",
    style: {
      transformOrigin: "378.868px 182.96px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m387.73 193.7a1.15 1.15 0 0 1 0-0.17v-0.53-1.91c0-1.67 0-4.06-0.05-7 0-5.94-0.05-14.15-0.08-23.37l0.17 0.17h-3.17l0.16-0.16v10.57 9.34c0 5.68-0.06 10.23-0.08 13l-0.06-0.06h2.31 0.82s-0.06 0-0.19 0h-0.56-2.35-0.07v-0.07c0-2.82 0-7.37-0.07-13v-9.34-5.17-5.4c0.07-0.08-0.17 0.16 0.17-0.18h3.3v0.17c0 9.26 0 17.52-0.07 23.49 0 2.94 0 5.32-0.05 7v1.88 0.48c-0.12 0.22-0.12 0.27-0.13 0.26z",
    fill: "#263238",
    style: {
      transformOrigin: "386.236px 177.061px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m395.3 193.7s0-0.1 0-0.29 0-0.49 0-0.85v-3.23c0-2.81 0-6.87-0.05-11.88 0-10 0-23.93-0.07-39.43l0.17 0.17h-3.14c0.33-0.33 0.1-0.08 0.17-0.15v9.57 9.09 16.18c0 9.7-0.07 17.07-0.09 20.82h2.35 0.79s-0.06 0-0.19 0h-0.57-2.38-0.05v-0.06c0-3.75-0.05-11.12-0.08-20.82v-16.18-9.09-9.55c0.08-0.08-0.17 0.15 0.17-0.19h3.3v0.19c0 15.55 0 29.48-0.07 39.55 0 5 0 9-0.05 11.84v3.2 0.82s-0.21 0.3-0.21 0.29z",
    fill: "#263238",
    style: {
      transformOrigin: "393.888px 165.755px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M59.6,197l2.67,46.83,78.35-4.47Zm13.09,18.17,33.7,18L73.82,235Z",
    fill: "#f90",
    style: {
      transformOrigin: "100.11px 220.415px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m67.38 201.09a9.61 9.61 0 0 1-1.24 2.91 9.45 9.45 0 0 1-1.73 2.67 9.51 9.51 0 0 1 1.24-2.94 9.6 9.6 0 0 1 1.73-2.64z",
    fill: "#263238",
    style: {
      transformOrigin: "65.895px 203.88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m79.4 207.3a9.4 9.4 0 0 1-1.24 2.87 8.9 8.9 0 0 1-1.71 2.59 9.12 9.12 0 0 1 1.23-2.87 8.64 8.64 0 0 1 1.72-2.59z",
    fill: "#263238",
    style: {
      transformOrigin: "77.925px 210.03px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m91.41 213.51a9.16 9.16 0 0 1-1.52 2.71 8.54 8.54 0 0 1-2 2.4 9.14 9.14 0 0 1 1.52-2.72 8.78 8.78 0 0 1 2-2.39z",
    fill: "#263238",
    style: {
      transformOrigin: "89.65px 216.065px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m103.23 220a8.62 8.62 0 0 1-1.52 2.72 9.22 9.22 0 0 1-2 2.4 8.62 8.62 0 0 1 1.52-2.72 9.22 9.22 0 0 1 2-2.4z",
    fill: "#263238",
    style: {
      transformOrigin: "101.47px 222.56px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m115.57 226.33a9.47 9.47 0 0 1-1.38 2.89 9.57 9.57 0 0 1-1.84 2.6 18.2 18.2 0 0 1 3.22-5.49z",
    fill: "#263238",
    style: {
      transformOrigin: "113.96px 229.075px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m128.38 233a8.27 8.27 0 0 1-1.22 2.74 8.52 8.52 0 0 1-1.7 2.47 8.43 8.43 0 0 1 1.23-2.75 8.09 8.09 0 0 1 1.69-2.46z",
    fill: "#263238",
    style: {
      transformOrigin: "126.92px 235.605px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M71.13,203.05c.13.08-.09.76-.5,1.54s-.85,1.33-1,1.26.09-.76.5-1.53S71,203,71.13,203.05Z",
    fill: "#263238",
    style: {
      transformOrigin: "70.3762px 204.451px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M75.06,205c.14.07-.09.76-.5,1.53s-.84,1.34-1,1.27.1-.76.5-1.54S74.93,204.94,75.06,205Z",
    fill: "#263238",
    style: {
      transformOrigin: "74.3066px 206.401px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M83.83,209.65c.13.08-.09.76-.5,1.54s-.85,1.34-1,1.26.09-.76.5-1.53S83.7,209.58,83.83,209.65Z",
    fill: "#263238",
    style: {
      transformOrigin: "83.0762px 211.051px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M87.77,211.62c.13.07-.09.76-.5,1.53s-.85,1.34-1,1.27.09-.76.5-1.54S87.63,211.55,87.77,211.62Z",
    fill: "#263238",
    style: {
      transformOrigin: "87.0162px 213.02px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M95.7,216.06c.14.07-.09.76-.5,1.53s-.84,1.34-1,1.27.09-.76.5-1.54S95.57,216,95.7,216.06Z",
    fill: "#263238",
    style: {
      transformOrigin: "94.9461px 217.461px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M99.46,218c.14.07-.09.76-.5,1.53s-.84,1.34-1,1.27.09-.77.5-1.54S99.33,218,99.46,218Z",
    fill: "#263238",
    style: {
      transformOrigin: "98.7061px 219.403px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M107.57,222.24c.13.08-.09.76-.5,1.54s-.84,1.33-1,1.26.09-.76.5-1.53S107.44,222.17,107.57,222.24Z",
    fill: "#263238",
    style: {
      transformOrigin: "106.814px 223.64px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M111.93,224.55c.13.08-.09.76-.5,1.54s-.85,1.34-1,1.26.09-.76.5-1.53S111.8,224.48,111.93,224.55Z",
    fill: "#263238",
    style: {
      transformOrigin: "111.176px 225.951px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M119.77,228.68c.13.07-.09.76-.5,1.53s-.85,1.34-1,1.27.09-.76.5-1.54S119.63,228.61,119.77,228.68Z",
    fill: "#263238",
    style: {
      transformOrigin: "119.016px 230.08px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M124.29,231c.13.08-.09.77-.5,1.54s-.85,1.34-1,1.26.09-.76.5-1.53S124.16,230.93,124.29,231Z",
    fill: "#263238",
    style: {
      transformOrigin: "123.536px 232.401px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m193.6 131.84s0-0.06 0-0.17 0-0.29 0-0.5v-1.91-7.22c0-6.2-0.05-15-0.08-25.64l0.15 0.14h-35.44l0.16-0.17v35.44l-0.14-0.15 25.64 0.08h7.22 0.06-7.18l-25.74 0.07h-0.25v-0.15-35.44-0.17h0.17 35.44 0.14v0.15c0 10.64-0.05 19.51-0.07 25.74v7.18 1.88 0.64z",
    fill: "#f90",
    style: {
      transformOrigin: "175.875px 113.945px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m193.6 131.84a2.4 2.4 0 0 1 0.27-0.19l0.81-0.52 3.14-2 11.54-7.13-0.06 0.11v-34.91l0.16 0.17h-0.09-34.94 0.06l-11.93 6.63-3.26 1.82-0.85 0.46-0.29 0.15a3.22 3.22 0 0 1 0.27-0.18l0.84-0.5 3.22-1.87 11.84-6.8h34.94 0.26v0.17 34.91 0.07h-0.06l-11.6 7.09-3.17 1.92-0.83 0.49z",
    fill: "#f90",
    style: {
      transformOrigin: "183.845px 109.46px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m209.42 87.16c0.05 0.08-3.45 2.21-7.82 4.76s-8 4.56-8 4.48 3.45-2.21 7.83-4.77 7.95-4.55 7.99-4.47z",
    fill: "#f90",
    style: {
      transformOrigin: "201.51px 91.78px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M159.84,130.38c0,.08-.3.37-.76.63s-.88.42-.92.34.29-.36.75-.63S159.79,130.3,159.84,130.38Z",
    fill: "#f90",
    style: {
      transformOrigin: "158.998px 130.865px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M163.2,128.45c.05.08-.29.37-.76.63s-.88.42-.92.34.29-.36.76-.63S163.15,128.37,163.2,128.45Z",
    fill: "#f90",
    style: {
      transformOrigin: "162.361px 128.935px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M166.56,126.52c.05.08-.29.37-.75.63s-.88.42-.93.34.29-.36.76-.63S166.52,126.44,166.56,126.52Z",
    fill: "#f90",
    style: {
      transformOrigin: "165.72px 127.005px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M169.93,124.59c0,.08-.3.36-.76.63s-.88.42-.93.34.3-.36.76-.63S169.88,124.51,169.93,124.59Z",
    fill: "#f90",
    style: {
      transformOrigin: "169.083px 125.075px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M173.29,122.66c0,.08-.29.36-.76.63s-.88.42-.92.34.29-.36.75-.63S173.24,122.58,173.29,122.66Z",
    fill: "#f90",
    style: {
      transformOrigin: "172.448px 123.145px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m174.14 119.27c0.09 0 0.16 0.43 0.16 1s-0.08 1-0.18 1-0.16-0.43-0.16-1 0.09-1.01 0.18-1z",
    fill: "#f90",
    style: {
      transformOrigin: "174.13px 120.27px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m174.17 115.39c0.09 0 0.17 0.43 0.16 1s-0.08 1-0.17 1-0.17-0.44-0.17-1 0.09-1 0.18-1z",
    fill: "#f90",
    style: {
      transformOrigin: "174.16px 116.39px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m174.2 111.51c0.09 0 0.17 0.44 0.16 1s-0.08 1-0.17 1-0.17-0.44-0.17-1 0.09-1 0.18-1z",
    fill: "#f90",
    style: {
      transformOrigin: "174.19px 112.51px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m174.23 107.63c0.09 0 0.17 0.44 0.16 1s-0.08 1-0.17 1-0.17-0.43-0.16-1 0.08-1 0.17-1z",
    fill: "#f90",
    style: {
      transformOrigin: "174.225px 108.63px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m174.26 103.76c0.09 0 0.17 0.43 0.16 1s-0.08 1-0.17 1-0.17-0.43-0.16-1 0.08-1 0.17-1z",
    fill: "#f90",
    style: {
      transformOrigin: "174.255px 104.76px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m174.29 99.88c0.1 0 0.17 0.43 0.16 1s-0.08 1-0.17 1-0.17-0.44-0.16-1 0.08-1 0.17-1z",
    fill: "#f90",
    style: {
      transformOrigin: "174.285px 100.88px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M174.32,96c.1,0,.17.44.16,1s-.08,1-.17,1-.17-.44-.16-1S174.23,96,174.32,96Z",
    fill: "#f90",
    style: {
      transformOrigin: "174.315px 97px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m174.35 92.12c0.1 0 0.17 0.44 0.16 1s-0.08 1-0.17 1-0.17-0.43-0.16-1 0.08-1 0.17-1z",
    fill: "#f90",
    style: {
      transformOrigin: "174.345px 93.12px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m174.38 88.25c0.1 0 0.17 0.43 0.16 1s-0.08 1-0.17 1-0.17-0.43-0.16-1 0.08-1 0.17-1z",
    fill: "#f90",
    style: {
      transformOrigin: "174.375px 89.25px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m207.49 122.08c0-0.08 0.43-0.15 1-0.15s1 0.07 1 0.15-0.43 0.16-1 0.16-1-0.07-1-0.16z",
    fill: "#f90",
    style: {
      transformOrigin: "208.49px 122.085px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m203.61 122.08c0-0.08 0.43-0.15 1-0.15s1 0.07 1 0.15-0.44 0.16-1 0.16-1-0.07-1-0.16z",
    fill: "#f90",
    style: {
      transformOrigin: "204.61px 122.085px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m199.73 122.08c0-0.08 0.43-0.15 1-0.15s1 0.07 1 0.15-0.43 0.16-1 0.16-1-0.07-1-0.16z",
    fill: "#f90",
    style: {
      transformOrigin: "200.73px 122.085px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m195.85 122.08c0-0.08 0.44-0.15 1-0.15s1 0.07 1 0.15-0.43 0.16-1 0.16-1-0.07-1-0.16z",
    fill: "#f90",
    style: {
      transformOrigin: "196.85px 122.085px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M192,122.08c0-.08.43-.15,1-.15s1,.07,1,.15-.43.16-1,.16S192,122.17,192,122.08Z",
    fill: "#f90",
    style: {
      transformOrigin: "193px 122.085px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m188.1 122.08c0-0.08 0.43-0.15 1-0.15s1 0.07 1 0.15-0.44 0.16-1 0.16-1-0.07-1-0.16z",
    fill: "#f90",
    style: {
      transformOrigin: "189.1px 122.085px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m184.22 122.08c0-0.08 0.43-0.15 1-0.15s1 0.07 1 0.15-0.43 0.16-1 0.16-1-0.07-1-0.16z",
    fill: "#f90",
    style: {
      transformOrigin: "185.22px 122.085px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m180.34 122.08c0-0.08 0.44-0.15 1-0.15s1 0.07 1 0.15-0.43 0.16-1 0.16-1-0.07-1-0.16z",
    fill: "#f90",
    style: {
      transformOrigin: "181.34px 122.085px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m176.47 122.08c0-0.08 0.43-0.15 1-0.15s1 0.07 1 0.15-0.43 0.16-1 0.16-1-0.07-1-0.16z",
    fill: "#f90",
    style: {
      transformOrigin: "177.47px 122.085px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M174.12,122.08c0-.08.09-.15.2-.15s.21.07.21.15-.09.16-.21.16A.18.18,0,0,1,174.12,122.08Z",
    fill: "#f90",
    style: {
      transformOrigin: "174.325px 122.086px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M213.71,110.27a4.6,4.6,0,0,0,.89,0,2.77,2.77,0,0,0,1.84-1.39,3.72,3.72,0,0,0-.1-3.37,1,1,0,0,0-.7-.56,1.24,1.24,0,0,0-.9.24,4.28,4.28,0,0,0-1.13,1.88,8.71,8.71,0,0,0-.5,2.41h-.33c0-2.57-.05-4.81-.05-6.41,0-.75,0-1.38,0-1.88a2.83,2.83,0,0,1,0-.68,3.42,3.42,0,0,1,.07.68c0,.5,0,1.13.08,1.88.06,1.6.12,3.84.17,6.41h-.33a9,9,0,0,1,.52-2.5,9.88,9.88,0,0,1,.48-1.1,2.73,2.73,0,0,1,.76-.93,1.55,1.55,0,0,1,1.16-.3,1.36,1.36,0,0,1,.9.72,3.92,3.92,0,0,1,0,3.65,2.79,2.79,0,0,1-2,1.39,2.1,2.1,0,0,1-.68,0A.62.62,0,0,1,213.71,110.27Z",
    fill: "#f90",
    style: {
      transformOrigin: "214.85px 105.474px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M115.42,276.23s.14,0,.41.12.67.21,1.18.42a23,23,0,0,1,4.26,2.22,23.63,23.63,0,0,1,5.6,5.15,20.83,20.83,0,0,1,4.18,9.12,20.31,20.31,0,0,1-1.55,12,18.87,18.87,0,0,1-3.9,5.6,18.13,18.13,0,0,1-2.79,2.26c-.53.3-1,.62-1.6.9s-1.1.55-1.69.76c-4.66,1.85-10,1.93-15.36,1.42-2.68-.26-5.38-.65-8.13-1.08a49.24,49.24,0,0,1-8.23-1.91,20.85,20.85,0,0,1-7.37-4.14,16.67,16.67,0,0,1-2.7-3.18A17.19,17.19,0,0,1,76,302.16a19.33,19.33,0,0,1-.79-7.89A21.11,21.11,0,0,1,77.39,287a24.29,24.29,0,0,1,9.92-9.76,32.83,32.83,0,0,1,11.62-3.7,45.47,45.47,0,0,1,10.08-.07,67.23,67.23,0,0,1,7.51,1.23c2,.46,3.6.88,4.66,1.17l1.2.35.41.14-.42-.1-1.21-.31c-1.06-.27-2.63-.67-4.67-1.1a67.19,67.19,0,0,0-7.51-1.15,44.57,44.57,0,0,0-10,.12,32.79,32.79,0,0,0-11.49,3.71,24,24,0,0,0-9.75,9.64,20.63,20.63,0,0,0-2.11,7.16,19.06,19.06,0,0,0,.78,7.73,16.42,16.42,0,0,0,1.68,3.64,16.08,16.08,0,0,0,2.62,3.1,20.68,20.68,0,0,0,7.23,4.06,49.14,49.14,0,0,0,8.18,1.89c2.73.43,5.44.82,8.1,1.08,5.3.51,10.61.44,15.19-1.38a17.77,17.77,0,0,0,9.81-9.3,20.14,20.14,0,0,0,1.58-11.82,20.75,20.75,0,0,0-4.09-9,23.85,23.85,0,0,0-5.5-5.15,25,25,0,0,0-4.21-2.28c-.51-.21-.9-.34-1.17-.45Z",
    fill: "#263238",
    style: {
      transformOrigin: "103.228px 294.847px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M88.72,302.07a3.21,3.21,0,0,1-.81.1l-2.23.11-.74,0a3.13,3.13,0,0,1-.85,0,.73.73,0,0,1-.42-.34,1.23,1.23,0,0,1-.13-.48l-.06-.91c-.07-1.26-.15-2.62-.23-4s-.17-2.79-.18-4.06a3.61,3.61,0,0,1,.42-1.79,2.52,2.52,0,0,1,1.22-1,5.09,5.09,0,0,1,2.25-.25,2.62,2.62,0,0,1,.81.15,4.72,4.72,0,0,1-.82,0,5.28,5.28,0,0,0-2.13.35,2.16,2.16,0,0,0-1,.95,3.36,3.36,0,0,0-.35,1.62c0,1.22.15,2.61.21,4s.14,2.79.21,4c.06.59-.07,1.33.34,1.43a2.6,2.6,0,0,0,.75,0h3A2.93,2.93,0,0,1,88.72,302.07Z",
    fill: "#263238",
    style: {
      transformOrigin: "85.8943px 295.863px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M87.6,295.52a5.83,5.83,0,0,1-2.08.24,5.72,5.72,0,0,1-2.09-.16,5.58,5.58,0,0,1,2.08-.24A5.68,5.68,0,0,1,87.6,295.52Z",
    fill: "#263238",
    style: {
      transformOrigin: "85.515px 295.56px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M98,293.66a17.77,17.77,0,0,1-3.17.16,20.07,20.07,0,0,1-3.16,0,9.38,9.38,0,0,1,3.15-.43A9.82,9.82,0,0,1,98,293.66Z",
    fill: "#263238",
    style: {
      transformOrigin: "94.835px 293.621px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m98.62 298.44a10.19 10.19 0 0 1-3.14 0.22 9.94 9.94 0 0 1-3.11-0.37 16.3 16.3 0 0 1 3.12 0 17.33 17.33 0 0 1 3.13 0.15z",
    fill: "#263238",
    style: {
      transformOrigin: "95.495px 298.456px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M115.43,301.31s0-.43,0-1.22a12.13,12.13,0,0,0-.6-3.28,3.34,3.34,0,0,0-1.16-1.89,1,1,0,0,0-1.09.07,2.74,2.74,0,0,0-.83,1,14,14,0,0,0-1,6.21l-.39,0a26.33,26.33,0,0,0-.06-4.6,18.31,18.31,0,0,0-.26-1.85,2.4,2.4,0,0,0-.84-1.44,1.25,1.25,0,0,0-1.46,0,2.22,2.22,0,0,0-.92,1.26,8.54,8.54,0,0,0-.28,1.59c-.06.53-.11,1.05-.13,1.56a24.61,24.61,0,0,0,0,2.85l-.31,0c-.08-2.25-.15-4.09-.2-5.44,0-.6,0-1.09,0-1.48a2.09,2.09,0,0,1,0-.52,2.75,2.75,0,0,1,.07.52l.12,1.48c.08,1.34.2,3.18.34,5.42h-.31a27.15,27.15,0,0,1,0-2.88c0-.51.06-1,.12-1.58a8.39,8.39,0,0,1,.29-1.66,2.61,2.61,0,0,1,1.06-1.48,1.82,1.82,0,0,1,1-.28,1.7,1.7,0,0,1,1,.33,2.79,2.79,0,0,1,1,1.67,17.77,17.77,0,0,1,.28,1.9,27.11,27.11,0,0,1,0,4.67l-.39,0a14,14,0,0,1,1.1-6.35,2.93,2.93,0,0,1,1-1.14,1.31,1.31,0,0,1,1.42-.07,3.55,3.55,0,0,1,1.25,2.07,11.62,11.62,0,0,1,.5,3.36c0,.4,0,.71-.05.91A1.24,1.24,0,0,1,115.43,301.31Z",
    fill: "#263238",
    style: {
      transformOrigin: "110.817px 297.955px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M124.19,300.68s-.14.17-.48.34a3.79,3.79,0,0,1-1.55.38,4.06,4.06,0,0,1-2.3-.63,4,4,0,0,1-1.28-5.29,4.1,4.1,0,0,1,1.76-1.61,3.74,3.74,0,0,1,1.55-.37,1.39,1.39,0,0,1,.58.08,5.76,5.76,0,0,0-2,.54,4,4,0,0,0-1.56,1.54,3.77,3.77,0,0,0,1.16,4.81,3.94,3.94,0,0,0,2.1.65A5.49,5.49,0,0,0,124.19,300.68Z",
    fill: "#263238",
    style: {
      transformOrigin: "121.13px 297.449px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M126.55,289.35a20.45,20.45,0,0,0-4.45.77l-.67.22.5-.51a13.93,13.93,0,0,0,2.48-3,4.5,4.5,0,0,0,.52-3.07c-.11-.47-.39-.84-.77-.85a2.44,2.44,0,0,0-1.13.3,4.41,4.41,0,0,0-1.38,1.11c-.27.33-.38.55-.41.53a1.33,1.33,0,0,1,.29-.62,3.79,3.79,0,0,1,1.37-1.26,2.58,2.58,0,0,1,1.28-.39,1,1,0,0,1,.73.35,1.75,1.75,0,0,1,.37.73,4.75,4.75,0,0,1-.52,3.36,12.92,12.92,0,0,1-2.59,3.09l-.17-.3a12.36,12.36,0,0,1,3.28-.52A3.61,3.61,0,0,1,126.55,289.35Z",
    fill: "#263238",
    style: {
      transformOrigin: "123.895px 286.46px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "278.015px 302.02px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "animable",
    points: "193.52 277.52 214.83 273.41 255.71 282.79 276.43 287.11 276.73 315.42 230.51 323.93 199.32 314.69 187.53 297.34",
    fill: "#ffbe9d",
    style: {
      transformOrigin: "232.13px 298.67px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M178.38,280.34l20.11-4.74s14.22,44,49.31,42.07c28.6-1.55,28.63-30.56,28.63-30.56l20.91,3.69s8.77,53.09-.84,90.33c-8,31-15.1,73.48-15.1,73.48H142.49l35.89-174.27Z",
    fill: "#f90",
    style: {
      transformOrigin: "221.745px 365.105px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M382.15,416.37S324.86,316,314.55,303.12c-11.29-14.1-20.3-12.47-20.3-12.47l-6.06,67.61,48.71,69.11,11.61,4.19Z",
    fill: "#f90",
    style: {
      transformOrigin: "335.17px 361.076px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m180.78 279.78s-32.56 2.6-44.24 56c-5.28 24.13-12 52.41-13.88 71.41-1.4 13.79 7.11 28.13 20.86 29.89l17.26 3.2a18.12 18.12 0 0 0 20.92-13.56l5.83-24.14-15.53-5.22 3.59-71.91z",
    fill: "#f90",
    style: {
      transformOrigin: "155.02px 360.182px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M300,328.12a3.54,3.54,0,0,1,.15.74c.09.54.19,1.26.33,2.15.07.47.14,1,.23,1.56s.12,1.19.18,1.86c.14,1.33.3,2.85.37,4.54a109.44,109.44,0,0,1,.08,11.87,142.45,142.45,0,0,1-1.44,14.46c-.75,5.1-1.69,9.92-2.64,14.28s-1.9,8.27-2.71,11.55-1.52,5.91-2,7.73c-.24.87-.43,1.57-.58,2.09a5.64,5.64,0,0,1-.23.72,4.07,4.07,0,0,1,.13-.74c.12-.54.29-1.24.49-2.12L294.2,391c.77-3.29,1.69-7.2,2.6-11.56s1.85-9.17,2.6-14.26,1.26-10,1.47-14.41.23-8.46,0-11.82c0-1.68-.18-3.2-.29-4.54-.05-.66-.1-1.28-.14-1.86s-.13-1.08-.18-1.56c-.1-.89-.17-1.61-.23-2.15A5.4,5.4,0,0,1,300,328.12Z",
    fill: "#263238",
    style: {
      transformOrigin: "296.602px 364.895px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M189.05,405.16a2.78,2.78,0,0,1-.17-.44c-.1-.33-.24-.75-.41-1.29l-.64-2.07a6.17,6.17,0,0,0-1.16-2.59,8.27,8.27,0,0,0-3-1.84,24.08,24.08,0,0,0-4.06-1.14,60.19,60.19,0,0,0-10-1h-.27l0-.26,2.94-19.17c1.89-12.07,3.61-23,4.86-31,.65-3.92,1.17-7.11,1.54-9.37.18-1.07.33-1.92.44-2.55,0-.26.09-.48.13-.66a.66.66,0,0,1,.06-.22.58.58,0,0,1,0,.23c0,.18,0,.4-.08.67-.08.63-.2,1.48-.34,2.56-.33,2.27-.8,5.47-1.37,9.4-1.22,8-2.88,18.91-4.72,31-1.08,6.9-2.09,13.43-3,19.16l-.23-.27a59.53,59.53,0,0,1,10.11,1.13,24,24,0,0,1,4.11,1.21,8.32,8.32,0,0,1,3.09,2,3.72,3.72,0,0,1,.78,1.39l.37,1.33c.23.81.42,1.51.58,2.09s.26,1,.34,1.31A2.16,2.16,0,0,1,189.05,405.16Z",
    fill: "#263238",
    style: {
      transformOrigin: "179.195px 368.36px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M144.2,413.32a5.63,5.63,0,0,1,.26-1.34,20.88,20.88,0,0,1,1.26-3.51,23.89,23.89,0,0,1,19.11-13.91,20.86,20.86,0,0,1,3.72-.12,6.1,6.1,0,0,1,1.36.17,44.54,44.54,0,0,0-5,.31,24.65,24.65,0,0,0-18.83,13.7A47.32,47.32,0,0,0,144.2,413.32Z",
    fill: "#263238",
    style: {
      transformOrigin: "157.055px 403.863px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M151.73,386.74a2.47,2.47,0,0,1,.78-.07,16.53,16.53,0,0,1,2.15.1,24.51,24.51,0,0,1,6.87,1.72,25.06,25.06,0,0,1,6.1,3.61,16.11,16.11,0,0,1,1.59,1.44c.35.37.54.58.51.61s-.88-.7-2.32-1.76a28.82,28.82,0,0,0-12.8-5.26C152.84,386.87,151.73,386.83,151.73,386.74Z",
    fill: "#263238",
    style: {
      transformOrigin: "160.732px 390.407px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M185.43,317.67a8.11,8.11,0,0,1-.07-1.43c0-.92-.06-2.24-.18-3.87A63.1,63.1,0,0,0,183,299.8a64.19,64.19,0,0,0-4.69-11.86c-.76-1.45-1.4-2.61-1.87-3.39a8.08,8.08,0,0,1-.68-1.26,7.54,7.54,0,0,1,.85,1.15c.53.76,1.22,1.89,2,3.33a56,56,0,0,1,6.9,24.58c.07,1.64.06,3,0,3.89A7.24,7.24,0,0,1,185.43,317.67Z",
    fill: "#263238",
    style: {
      transformOrigin: "180.659px 300.48px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "301.624px 349.41px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m298.52 372.91c8.3-14.07 8.48-32.35 1.23-47a131.3 131.3 0 0 1-1.48 46.94",
    style: {
      transformOrigin: "301.624px 349.41px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    opacity: 0.3,
    style: {
      transformOrigin: "222.55px 386.996px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m224.62 388.82c-6.3 1.85-15 2.3-21.17 0 4.81 6.83 14.08 9.3 22.12 7.08s15.46-10.27 16.08-18.6c-3.89 5.26-10.72 9.7-17.03 11.52z",
    style: {
      transformOrigin: "222.55px 386.996px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M247.8,366.1a2.62,2.62,0,0,1-.15.56c-.12.36-.26.91-.54,1.57a32.58,32.58,0,0,1-2.71,5.49,35.21,35.21,0,0,1-5.69,7.08,34.44,34.44,0,0,1-19.79,9.5,35.29,35.29,0,0,1-9.08,0,33.69,33.69,0,0,1-6-1.31c-.7-.21-1.21-.44-1.57-.57a3.5,3.5,0,0,1-.53-.23,22,22,0,0,1,2.15.6,36.86,36.86,0,0,0,25.46-2.11,36.63,36.63,0,0,0,17.55-18.54C247.48,366.84,247.75,366.08,247.8,366.1Z",
    fill: "#263238",
    style: {
      transformOrigin: "224.77px 378.346px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M177.56,436.11s-.07.11-.25.27a6.89,6.89,0,0,1-.81.69,12.67,12.67,0,0,1-3.44,1.82,19.73,19.73,0,0,1-5.68,1,52,52,0,0,1-7-.25c-5-.43-9.44-1.16-12.65-1.73-1.61-.29-2.91-.54-3.8-.73a6.81,6.81,0,0,1-1.39-.34,8.6,8.6,0,0,1,1.42.14l3.83.56c3.22.49,7.68,1.15,12.64,1.58a56.93,56.93,0,0,0,7,.29,20.41,20.41,0,0,0,5.58-.9A17.2,17.2,0,0,0,177.56,436.11Z",
    fill: "#263238",
    style: {
      transformOrigin: "160.05px 438.013px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m290.5 173 4.11-4c5.47 2.38 8 8.73 8.93 14.63s0.79 12.1 3.3 17.52c1.92 4.17 5.41 8 5 12.61-0.39 4.35-4.33 7.87-4.35 12.24 0 4.21 3.5 7.44 5.54 11.12 4.13 7.45 6.81 37.93 4.65 46.18-18.17-1.57-50.35-3.51-68.53-7.69 4.79-31.32 24.96-75.52 41.35-102.61z",
    fill: "#263238",
    style: {
      transformOrigin: "283.798px 226.15px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m264.81 295.87",
    fill: "#ffbe9d",
    style: {
      transformOrigin: "264.81px 295.87px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m298.63 200.92c1.26-21.29-14.2-40.77-35.75-43.34-22.87-2.72-43.1 13.66-45 35.94l-5.36 89.94a7.81 7.81 0 0 0 1.38 4.89c5.28 7.72 14.84 13.76 23.39 14.95 8.27 1.15 16.66-1 23.7-4.92a7.66 7.66 0 0 0 3.89-6.58l0.37-20.13a0.12 0.12 0 0 1 0.13-0.13 27.33 27.33 0 0 0 5.65-0.16c5.32-1.3 18.89-6.52 23.45-26.44 1.52-6.6 3.04-25.35 4.15-44.02z",
    fill: "#ffbe9d",
    style: {
      transformOrigin: "255.605px 230.447px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M269.05,230.33c0-.2,2.23-.42,5.84-.62.91,0,1.78-.15,2-.75a4.48,4.48,0,0,0-.44-2.68l-2.24-7c-3.1-9.92-5.28-18.05-4.88-18.16s3.25,7.82,6.35,17.74c.74,2.45,1.45,4.78,2.13,7,.28,1,.79,2.22.24,3.53a2.23,2.23,0,0,1-1.57,1.19,6.2,6.2,0,0,1-1.55.11C271.29,230.67,269.06,230.53,269.05,230.33Z",
    fill: "#263238",
    style: {
      transformOrigin: "273.672px 215.909px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m292.75 208.45c-0.39 0.43-2.75-1.55-6.13-1.65s-5.9 1.67-6.26 1.21c-0.18-0.21 0.23-1 1.33-1.82a8.11 8.11 0 0 1 5-1.52 8 8 0 0 1 4.87 1.87c1.05 0.9 1.44 1.72 1.19 1.91z",
    fill: "#263238",
    style: {
      transformOrigin: "286.571px 206.588px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m258.41 209.31c-0.46 0.43-2.92-1.8-6.61-2.12s-6.56 1.37-6.93 0.87c-0.18-0.23 0.32-1 1.57-1.82a9.18 9.18 0 0 1 5.56-1.24 9 9 0 0 1 5.22 2.27c1.09 0.97 1.41 1.85 1.19 2.04z",
    fill: "#263238",
    style: {
      transformOrigin: "251.655px 207.161px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M265.25,271.53s-13.78.15-30.26-11.17c0,0,4.26,18.18,30.15,17.61Z",
    fill: "#eb996e",
    style: {
      transformOrigin: "250.12px 269.172px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M267,238.63a6.49,6.49,0,0,0-5.58-2.73,5.84,5.84,0,0,0-4.17,1.84,3.59,3.59,0,0,0-.55,4.14c.87,1.39,2.85,1.84,4.58,1.48A13.51,13.51,0,0,0,266,241a4.16,4.16,0,0,0,1.08-1,1.17,1.17,0,0,0,.08-1.3",
    fill: "#eb996e",
    style: {
      transformOrigin: "261.8px 239.686px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M258.45,232c.58,0,.35,3.8,3.47,6.72s7.25,2.78,7.25,3.31c0,.25-1,.68-2.7.6a9.78,9.78,0,0,1-6.06-2.55,8.22,8.22,0,0,1-2.66-5.61C257.7,232.88,258.19,232,258.45,232Z",
    fill: "#263238",
    style: {
      transformOrigin: "263.458px 237.32px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M259,195.37c-.42.92-3.93.21-8.12.38s-7.64,1-8.14.15c-.21-.43.43-1.27,1.86-2.09a14.3,14.3,0,0,1,12.38-.4C258.43,194.13,259.14,194.93,259,195.37Z",
    fill: "#263238",
    style: {
      transformOrigin: "250.859px 194.235px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M293.48,196.12c-.72.8-3.57,0-7,0s-6.31.57-7-.26c-.3-.4.15-1.2,1.41-2a11.66,11.66,0,0,1,11.26.24C293.39,194.91,293.8,195.73,293.48,196.12Z",
    fill: "#263238",
    style: {
      transformOrigin: "286.487px 194.502px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m266 153.08c-1.86-3.16-5.31-4.6-9.17-5.18-15.76-2.39-33.34 7.1-42.17 20.36s-9.3 33.05-2.84 47.61l9.83-6.14c19.73-8.14 33.66-27.15 46.35-46.79 1.77-2.67-0.35-7.11-2-9.86z",
    fill: "#263238",
    style: {
      transformOrigin: "238.054px 181.7px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m290.28 161.75c-6.59-7.5-11.38-15-25.06-9.76-2 3.83 2 8.8 5.44 11.7 5 4.26 9.29 7.13 12.55 10.18 6.58 6.15 14.06 26.84 14.71 38.13 0 0.71 1.25-9.69 2-9.8 0.92-0.14 4.63-4.68 4.12-10.88-1.76-21.19-7.17-22.08-13.76-29.57z",
    fill: "#263238",
    style: {
      transformOrigin: "284.386px 181.138px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M256.87,147.9a5.63,5.63,0,0,1,3.07.26,13.28,13.28,0,0,1,6.22,4.09A11.15,11.15,0,0,1,267.4,154a8.94,8.94,0,0,1,.72,1.89,20.67,20.67,0,0,1,.81,3.24c.27,1.93-.19,3.1-.29,3.07s.05-1.18-.37-2.95a30.17,30.17,0,0,0-1-3.09,9.58,9.58,0,0,0-.7-1.71,11.29,11.29,0,0,0-1.16-1.62,14.7,14.7,0,0,0-5.71-4.06C258,148.16,256.85,148.06,256.87,147.9Z",
    fill: "#455a64",
    style: {
      transformOrigin: "262.942px 154.998px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m289.63 215a3 3 0 0 1-2.83 3 2.87 2.87 0 0 1-3.13-2.65 3 3 0 0 1 2.83-3.07 2.86 2.86 0 0 1 3.13 2.72z",
    fill: "#263238",
    style: {
      transformOrigin: "286.65px 215.14px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m256.69 215.16a3 3 0 0 1-2.83 3.07 2.86 2.86 0 0 1-3.13-2.64 3 3 0 0 1 2.83-3.08 2.86 2.86 0 0 1 3.13 2.65z",
    fill: "#263238",
    style: {
      transformOrigin: "253.71px 215.37px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M166.05,240.19c1.86-3.06,4-5.94,7.4-7.21s7.26-2,9.93-4.48c4.19-3.85,4-10.25,3.62-15.83s-.48-12,3.8-15.75c3.58-3.13,9.27-3.41,12.37-7,2.07-2.39,2.48-5.69,3.2-8.74,2-8.17,6.47-22.44,30.55-30.65l-21.3,80.94c1.59.45,5.39,4.07,5.6,6.52.19,2.29-.8,4.61-.82,6.91,0,2.81,3.06,4.49,5,6.57,2.46,2.65,3.22,6.47,2.84,10a70.22,70.22,0,0,1-3.85,14.11c-19.76-2-48.6-2.64-63.66-15.24C158,258.06,161.91,247,166.05,240.19Z",
    fill: "#263238",
    style: {
      transformOrigin: "198.371px 213.055px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m221.69 209.73c-0.37-0.2-14.92-6-15.85 9.35s14.64 13.07 14.69 12.64 1.16-21.99 1.16-21.99z",
    fill: "#ffbe9d",
    style: {
      transformOrigin: "213.745px 220.291px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M216.21,225.64c-.07-.06-.28.17-.75.34a2.66,2.66,0,0,1-2-.07c-1.58-.7-2.79-3.35-2.7-6.11a8.91,8.91,0,0,1,1-3.77,3.12,3.12,0,0,1,2.13-1.93,1.36,1.36,0,0,1,1.53.83c.18.44.06.74.14.77s.35-.24.26-.88a1.67,1.67,0,0,0-.54-1,2,2,0,0,0-1.45-.48,3.74,3.74,0,0,0-2.93,2.2,9.11,9.11,0,0,0-1.18,4.22c-.09,3.09,1.31,6.07,3.49,6.84a2.82,2.82,0,0,0,2.46-.26C216.16,226,216.26,225.67,216.21,225.64Z",
    fill: "#eb996e",
    style: {
      transformOrigin: "212.969px 220.052px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m276.14 213.74a24.22 24.22 0 0 1 0.49-3.43 14 14 0 0 1 18.16-9.91 13 13 0 0 1 3.54 1.84 12.8 12.8 0 0 1 3 2.9 13.8 13.8 0 0 1 0.26 16.4 13 13 0 0 1-2.88 3 12.78 12.78 0 0 1-3.48 1.95 13.91 13.91 0 0 1-7.29 0.74 13.76 13.76 0 0 1-5.91-2.49 14.08 14.08 0 0 1-5.27-7.57 26 26 0 0 1-0.6-3.42 2.07 2.07 0 0 0 0 0.23v0.68a7.14 7.14 0 0 0 0.11 1.09 9.59 9.59 0 0 0 0.28 1.47 14.11 14.11 0 0 0 5.25 7.82 14.22 14.22 0 0 0 13.59 1.9 14.32 14.32 0 0 0 6.61-5.1 14.28 14.28 0 0 0-0.27-17 13.55 13.55 0 0 0-3.1-3 13.3 13.3 0 0 0-3.63-1.84 14.22 14.22 0 0 0-13.52 2.33 14.08 14.08 0 0 0-5 8 10.73 10.73 0 0 0-0.24 1.48 7.88 7.88 0 0 0-0.07 1.1v0.67a1.85 1.85 0 0 0-0.03 0.16z",
    fill: "#455a64",
    style: {
      transformOrigin: "290.406px 213.547px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M237.5,214.36a24.9,24.9,0,0,1,.48-3.43,14.09,14.09,0,0,1,5-7.74,13.83,13.83,0,0,1,5.83-2.68,14,14,0,0,1,7.31.51,13.29,13.29,0,0,1,3.54,1.84,13,13,0,0,1,3,2.9,13.81,13.81,0,0,1,.27,16.39,13.1,13.1,0,0,1-2.89,3,12.75,12.75,0,0,1-3.48,1.95,13.91,13.91,0,0,1-7.29.74,13.71,13.71,0,0,1-5.9-2.49,14.11,14.11,0,0,1-5.28-7.57,25,25,0,0,1-.59-3.42.82.82,0,0,0,0,.23c0,.18,0,.41,0,.68a5.92,5.92,0,0,0,.1,1.09,8.62,8.62,0,0,0,.29,1.47,14,14,0,0,0,5.25,7.82,14.21,14.21,0,0,0,6,2.62,14.39,14.39,0,0,0,7.53-.72,14.18,14.18,0,0,0,6.61-5.1,14.28,14.28,0,0,0-.27-17,14.31,14.31,0,0,0-6.77-4.89,14.33,14.33,0,0,0-7.55-.47,14.21,14.21,0,0,0-11,10.79,8.36,8.36,0,0,0-.24,1.48,5.62,5.62,0,0,0-.07,1.1v.67A.6.6,0,0,0,237.5,214.36Z",
    fill: "#455a64",
    style: {
      transformOrigin: "251.665px 214.135px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M265.1,213.31c.08.05.48-.6,1.41-1.35a6.82,6.82,0,0,1,8.52-.15c1,.71,1.38,1.35,1.45,1.29a3.58,3.58,0,0,0-1.22-1.58,6.69,6.69,0,0,0-9,.17A3.61,3.61,0,0,0,265.1,213.31Z",
    fill: "#455a64",
    style: {
      transformOrigin: "270.79px 211.588px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M218.17,208.75a13.79,13.79,0,0,0,2.83.58c1.77.28,4.22.54,6.92.78l6.93.62a18.89,18.89,0,0,0,2.87.22,13.92,13.92,0,0,0-2.83-.59c-1.76-.27-4.21-.53-6.92-.77l-6.92-.62A17.53,17.53,0,0,0,218.17,208.75Z",
    fill: "#455a64",
    style: {
      transformOrigin: "227.945px 209.85px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m298.46 222.39a18.12 18.12 0 0 0 3-4.83 18.38 18.38 0 0 0 0.87-5.63 4 4 0 0 1 0.3 1.7 11.06 11.06 0 0 1-0.68 4.11 10.87 10.87 0 0 1-2.16 3.56c-0.73 0.78-1.29 1.14-1.33 1.09z",
    fill: "#fff",
    style: {
      transformOrigin: "300.547px 217.162px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M300.88,206.59c.08-.12.65.17,1,.85s.2,1.3.06,1.29-.26-.52-.53-1.07S300.79,206.7,300.88,206.59Z",
    fill: "#fff",
    style: {
      transformOrigin: "301.48px 207.647px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M263.16,219.36c-.08,0,.2-.8.43-2.09a14.28,14.28,0,0,0-1.83-9.81c-.67-1.12-1.21-1.74-1.15-1.8a5.43,5.43,0,0,1,1.46,1.6A12.72,12.72,0,0,1,264,217.34,5.46,5.46,0,0,1,263.16,219.36Z",
    fill: "#fff",
    style: {
      transformOrigin: "262.465px 212.51px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M210,231.51s-.21.3-.51.85a5.32,5.32,0,0,0-.66,2.55,4.69,4.69,0,0,0,1.42,3.48,5,5,0,0,0,4.32,1.39,5.1,5.1,0,0,0,3.58-2.81,4.75,4.75,0,0,0,.11-3.76,5.43,5.43,0,0,0-1.5-2.16c-.48-.41-.8-.58-.78-.62a2.3,2.3,0,0,1,.9.46,5.13,5.13,0,0,1,1.72,2.18,5,5,0,0,1,0,4.1,5.28,5.28,0,0,1-8.68,1.56,5,5,0,0,1-1.45-3.83,5.11,5.11,0,0,1,.85-2.64C209.67,231.71,210,231.49,210,231.51Z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "213.75px 235.401px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m294.47 243.31a4.23 4.23 0 0 0 2.66 0.16 5.22 5.22 0 0 0 2.45-1.51 6.34 6.34 0 0 0 1.58-3.14 5.7 5.7 0 0 0-0.42-3.48 6.36 6.36 0 0 0-1.79-2.29 10.41 10.41 0 0 0-2.4-1.31 1.72 1.72 0 0 1 0.75 0.1 5.83 5.83 0 0 1 1.88 0.91 6.55 6.55 0 0 1 2 2.39 6 6 0 0 1 0.5 3.77 6.69 6.69 0 0 1-1.76 3.39 5.4 5.4 0 0 1-2.71 1.53 3.73 3.73 0 0 1-2.09-0.11c-0.47-0.19-0.67-0.39-0.65-0.41z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "298.129px 237.831px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M239,441.87l14.83,4.39s8.18,3.51,12.16,4.42c4.94,1.13,8.31-.4,8.49-3.15s-3.66-3.1-3.66-3.1a76,76,0,0,1-9.5-4.39,16.83,16.83,0,0,1-5.3-6l5.3.73s11.15,8,15.35,10.42,5.12-1.83,5.48-3.11-12.42-14.25-12.42-14.25,12.24,7.86,14.43,9.82,5.49,2.6,6.22,1.33,2.74-1.28,0-6.7-24.67-20-24.67-20l6-1.28,6.58,2.93a16.21,16.21,0,0,0,2.74,6.26c2.37,3.52,6.58,0,6.58,0L285,406.69l-13-8.14s-13.52,1.65-15.53,2.56-4.21,4.74-4.21,4.74l-3.65,1.48c-5.67,1.64-5.48,7.31-7.31,7.49s-55.17-10.22-55.17-10.22l-4.83-1.26c-8,6.07-11.19,16.1-12.6,25,0,0-1.47,4.36,0,6.76Z",
    fill: "#ffbe9d",
    style: {
      transformOrigin: "229.912px 424.803px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m229.21 432.38a2.73 2.73 0 0 1-0.05-0.87 5 5 0 0 1 0.09-1 7.65 7.65 0 0 1 0.26-1.34 18.9 18.9 0 0 1 3.73-6.87 40.86 40.86 0 0 1 5.52-5.53 16.34 16.34 0 0 1 2.59-1.93 26.85 26.85 0 0 1-2.35 2.16 51.74 51.74 0 0 0-5.36 5.58 20.6 20.6 0 0 0-3.77 6.65c-0.59 1.91-0.55 3.16-0.66 3.15z",
    fill: "#eb996e",
    style: {
      transformOrigin: "235.248px 423.61px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M252.31,405.85s-.44.23-1.12.78a12.14,12.14,0,0,0-2.43,2.79,13.26,13.26,0,0,0-1.22,2.25,12.15,12.15,0,0,0-.58,2.86,7.2,7.2,0,0,1-1.18,3.16,12.82,12.82,0,0,0-1.77,3,8,8,0,0,0,0,5.64l.07.19-.17.11a11.12,11.12,0,0,0-4.71,6.47,18,18,0,0,0-.45,3.2,2.6,2.6,0,0,1-.1-.86,10.06,10.06,0,0,1,.26-2.41,11.1,11.1,0,0,1,4.74-6.82l-.1.3a8.56,8.56,0,0,1,0-6,12.38,12.38,0,0,1,1.84-3.07,6.76,6.76,0,0,0,1.12-3,9.41,9.41,0,0,1,2-5.23,10.91,10.91,0,0,1,2.62-2.75,4,4,0,0,1,.9-.51A1.17,1.17,0,0,1,252.31,405.85Z",
    fill: "#eb996e",
    style: {
      transformOrigin: "245.478px 421.075px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m265.15 411.83a8.21 8.21 0 0 1-7-2.48c0.1-0.12 1.44 0.91 3.37 1.58s3.63 0.75 3.63 0.9z",
    fill: "#eb996e",
    style: {
      transformOrigin: "261.65px 410.619px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m268.57 426.6a33.09 33.09 0 0 1-5.61-2.14 35.31 35.31 0 0 1-5.4-2.62 36.12 36.12 0 0 1 5.61 2.14 35.31 35.31 0 0 1 5.4 2.62z",
    fill: "#eb996e",
    style: {
      transformOrigin: "263.065px 424.22px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m256.54 433.9a48 48 0 0 1-5.68-2.34 7.43 7.43 0 0 1 3 0.78 7.16 7.16 0 0 1 2.68 1.56z",
    fill: "#eb996e",
    style: {
      transformOrigin: "253.7px 432.73px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m266.73 427.55a7.16 7.16 0 0 0-3.53 4.45c-0.07 0-0.13-0.35 0-0.91a4.67 4.67 0 0 1 2.66-3.37c0.49-0.21 0.85-0.23 0.87-0.17z",
    fill: "#eb996e",
    style: {
      transformOrigin: "264.927px 429.76px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m272.09 419.44c0.06 0.14-0.92 0.64-1.58 1.76a15.31 15.31 0 0 0-0.84 2.2 2.65 2.65 0 0 1 0.4-2.47c0.76-1.28 2-1.63 2.02-1.49z",
    fill: "#eb996e",
    style: {
      transformOrigin: "270.809px 421.406px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M270.58,404.75c-.05,0-.25-.23-.4-.71a3.77,3.77,0,0,1,0-2,3.72,3.72,0,0,1,1-1.7c.36-.35.66-.47.69-.42a10,10,0,0,0-1.15,2.25A10.91,10.91,0,0,0,270.58,404.75Z",
    fill: "#eb996e",
    style: {
      transformOrigin: "270.957px 402.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m378.69 409.35s-0.67-13.12-14.27-15.84-37.42 8.84-37.42 8.84l-66.74 46.51 2 5.75 67.74-9.44 6.2 2.38 47.58-31.26 44.9-32.46-5-3.91s-12.58 8.67-20.9 12.4-20.35 10.27-24.09 17.03z",
    fill: "#f5f5f5",
    style: {
      transformOrigin: "344.47px 417.265px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m259.23 456.51 56.48-35.09 59.71-9.59s3 4.34 8.07 3.28l49.1-34 0.93 2.05-95.22 66.9a8.17 8.17 0 0 1-8.29-1.62z",
    fill: "#455a64",
    style: {
      transformOrigin: "346.375px 418.81px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M375.42,411.83a2.2,2.2,0,0,1-.46.38l-1.38,1c-1.2.86-2.93,2.11-5,3.69-4.24,3.15-10,7.64-16.22,12.73s-11.81,9.82-15.81,13.27L331.78,447l-1.3,1.1a2.32,2.32,0,0,1-.47.36s.12-.16.4-.43l1.23-1.18c1.08-1,2.65-2.46,4.63-4.21,3.94-3.52,9.47-8.28,15.72-13.39s12-9.55,16.33-12.63c2.14-1.55,3.91-2.75,5.15-3.56l1.43-.92A3.31,3.31,0,0,1,375.42,411.83Z",
    fill: "#263238",
    style: {
      transformOrigin: "352.715px 430.145px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m374.81 404.53c-5.41-5.81-13.93-7.88-21.85-7.26s-15.43 3.57-22.82 6.5l-69.09 47.29 0.62 1.78 69.46-47s15.52-5 22.39-5.86c11.48-1.43 21.29 4.55 21.29 4.55z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "317.93px 425.002px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m385.65 410.75 33.22-22.41s-27.22 14.16-33.22 22.41z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "402.26px 399.545px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M261.05,451.06a1.69,1.69,0,0,1,.28-.23l.86-.61,3.31-2.33,12.24-8.48,40.5-27.81,11.76-8,0,0h0a83.33,83.33,0,0,1,21-6.31,31.41,31.41,0,0,1,17.22,2.43,21.35,21.35,0,0,1,5.51,3.7,16.29,16.29,0,0,1,3.08,3.91,12.9,12.9,0,0,1,1.2,2.89c.07.33.13.59.18.79a2.32,2.32,0,0,1,.05.27,16.33,16.33,0,0,0-1.58-3.86,16.74,16.74,0,0,0-3.1-3.81,22.06,22.06,0,0,0-5.48-3.6,31.39,31.39,0,0,0-17-2.28A84.05,84.05,0,0,0,330.24,404l.05,0-11.76,8L278,439.71l-12.34,8.35-3.36,2.24-.89.58A1.94,1.94,0,0,1,261.05,451.06Z",
    fill: "#263238",
    style: {
      transformOrigin: "319.645px 424.021px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M321.53,415.31a2.18,2.18,0,0,1,.52-.32c.35-.19.87-.48,1.54-.82,1.35-.7,3.32-1.68,5.8-2.8a75.4,75.4,0,0,1,20.27-6.21,44.18,44.18,0,0,1,21,1.92,31.8,31.8,0,0,1,5.81,2.79c.66.38,1.13.75,1.46,1a3.25,3.25,0,0,1,.49.37s-.73-.42-2.05-1.17a35.27,35.27,0,0,0-5.83-2.61,45.24,45.24,0,0,0-20.83-1.75,80,80,0,0,0-20.19,6c-2.49,1.08-4.48,2-5.86,2.65l-1.58.73A3,3,0,0,1,321.53,415.31Z",
    fill: "#263238",
    style: {
      transformOrigin: "349.975px 409.988px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M426.9,382.42s-.14.13-.43.33l-1.29.86-4.79,3.08c-4.06,2.6-9.65,6.19-15.78,10.23S393,404.67,389,407.37l-4.73,3.18-1.3.85a2.12,2.12,0,0,1-.47.26,2.56,2.56,0,0,1,.41-.35l1.25-.93c1.08-.8,2.66-1.93,4.63-3.32,3.94-2.77,9.42-6.54,15.56-10.58s11.77-7.58,15.87-10.1c2.05-1.26,3.72-2.26,4.88-2.94l1.35-.78A2.74,2.74,0,0,1,426.9,382.42Z",
    fill: "#263238",
    style: {
      transformOrigin: "404.7px 397.04px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M396.68,418.38a23.28,23.28,0,0,1-2.57,4.62c-1.28,1.52-5.46,3.64-5.79,6.53s.35,9.67-4.17,14.83a25.38,25.38,0,0,1-10.71,7l-17.83-1.74-28.48-11.21a2.5,2.5,0,0,1-1.82-3,3.6,3.6,0,0,1,3-2.68l.68-.11s-1.64-1.34.71-3.69c2-2,6.27-.87,8.47-.14s15.1,6.12,17.41,6.95c2.05.73,3.63,1.38,3.63,1.38s-16.51-11.14-16.74-12.6c-.27-1.75-.09-2.55,1.6-3.77,2-1.45,5.28.1,8.46,1.44,2.37,1,17.48,8.46,17.48,8.46s.68-.66,0-2-5.7-7.8-6.49-9-1-1.88-.21-2.89c1.1-1.43,4-2.11,6.67.33,1.69,1.56,7.7,5.6,7.7,5.6l27.74-20.24s3.45-.09,2.25,4.72S396.68,418.38,396.68,418.38Z",
    fill: "#ffbe9d",
    style: {
      transformOrigin: "366.583px 426.905px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m376 435.25a7.07 7.07 0 0 1-5-4.2c0.13-0.08 0.94 1.16 2.32 2.31s2.75 1.74 2.68 1.89z",
    fill: "#eb996e",
    style: {
      transformOrigin: "373.501px 433.148px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M378.28,423.18c0-.06.37-.17,1-.09a4.33,4.33,0,0,1,3.47,2.87c.19.58.16,1,.09,1a7.83,7.83,0,0,0-1.76-2.48A8,8,0,0,0,378.28,423.18Z",
    fill: "#eb996e",
    style: {
      transformOrigin: "380.587px 425.011px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m379.59 428.75c-0.15 0-0.22-1.49-0.81-3.19s-1.42-2.95-1.3-3a5.59 5.59 0 0 1 1.79 2.87 5.51 5.51 0 0 1 0.32 3.32z",
    fill: "#eb996e",
    style: {
      transformOrigin: "378.59px 425.655px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M396,416.94c0,.05-.35-.15-.71-.63a4.59,4.59,0,0,1-.5-4.45c.24-.54.51-.81.56-.77a6.54,6.54,0,0,0,.65,5.85Z",
    fill: "#eb996e",
    style: {
      transformOrigin: "395.216px 414.017px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m370.93 442.23a4.37 4.37 0 0 1-1.95 0 13 13 0 0 1-4.4-1.64 24.34 24.34 0 0 1-3.79-2.75 6.51 6.51 0 0 1-1.37-1.36 7.78 7.78 0 0 1 1.6 1.07 37.5 37.5 0 0 0 3.82 2.59 15.75 15.75 0 0 0 4.21 1.73c1.14 0.24 1.88 0.28 1.88 0.36z",
    fill: "#eb996e",
    style: {
      transformOrigin: "365.175px 439.41px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M375.57,439.37c.14,0,.15,1-.69,1.83s-1.86.79-1.84.65.79-.34,1.47-1S375.42,439.35,375.57,439.37Z",
    fill: "#eb996e",
    style: {
      transformOrigin: "374.341px 440.649px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M382.38,434.37c.06,0,.06.27-.13.63a2.46,2.46,0,0,1-1.13,1,2.52,2.52,0,0,1-1.51.22c-.4-.08-.6-.24-.57-.3s.92.08,1.86-.39S382.24,434.32,382.38,434.37Z",
    fill: "#eb996e",
    style: {
      transformOrigin: "380.726px 435.31px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m358.36 445.72c-0.05 0.13-6.68-2.63-14.8-6.18s-14.66-6.54-14.56-6.66 6.69 2.64 14.81 6.19 14.61 6.52 14.55 6.65z",
    fill: "#eb996e",
    style: {
      transformOrigin: "343.68px 439.3px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "250px 454.64px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M475.16,454.64c0,.14-100.82.26-225.15.26s-225.17-.12-225.17-.26,100.8-.26,225.17-.26S475.16,454.49,475.16,454.64Z",
    fill: "#263238",
    style: {
      transformOrigin: "250px 454.64px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "animable",
    style: {
      transformOrigin: "144.723px 398.962px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "m37.72 348.11 21.7 106.53h188.35a3.76 3.76 0 0 0 3.76-3.76 3.76 3.76 0 0 0-3.76-3.77h-37.92l-20.12-99.11a4.1 4.1 0 0 0-4-3.29l-143.93-1.54a4.12 4.12 0 0 0-4.08 4.94z",
    fill: "#e0e0e0",
    style: {
      transformOrigin: "144.584px 398.905px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M37.72,348.11l-.06-.32a4.11,4.11,0,0,1,0-1,4.16,4.16,0,0,1,2-3.11,4,4,0,0,1,1.24-.5,7.14,7.14,0,0,1,1.48-.09l3.39,0,8.48.07,54.43.51,37.94.39,21.26.21,11.14.12,5.7.06c.49,0,.94,0,1.46,0a4.39,4.39,0,0,1,1.46.43,4.29,4.29,0,0,1,2.06,2.16,6.69,6.69,0,0,1,.4,1.45l.29,1.43c.19,1,.39,1.92.59,2.88q.58,2.89,1.18,5.82,1.19,5.85,2.41,11.85,2.44,12,5,24.53c3.39,16.7,6.93,34.07,10.56,52l-.25-.2h37.29a7.48,7.48,0,0,1,1.47.09,4,4,0,0,1,2.46,1.65,4,4,0,0,1,.67,2.89,4,4,0,0,1-2.05,2.93,4.11,4.11,0,0,1-1.78.48H147.85l-88.43,0h-.16l0-.16c-6.64-32.75-12-59.38-15.77-77.84-1.86-9.22-3.3-16.4-4.28-21.28q-.72-3.66-1.1-5.55c-.25-1.26-.36-1.9-.36-1.9s.15.64.41,1.88.66,3.12,1.16,5.54c1,4.88,2.49,12.05,4.39,21.27,3.78,18.45,9.23,45.07,15.94,77.8l-.2-.16,88.43-.05H247.9a3.64,3.64,0,0,0,1.54-.41,3.54,3.54,0,0,0,1.79-2.55,3.59,3.59,0,0,0-.58-2.53,3.55,3.55,0,0,0-2.15-1.43,7.48,7.48,0,0,0-1.36-.08h-37.5l0-.2c-3.63-17.91-7.16-35.28-10.54-52q-2.55-12.54-5-24.54l-2.4-11.85c-.39-1.95-.79-3.89-1.18-5.81-.19-1-.39-1.93-.58-2.88l-.29-1.44a7.13,7.13,0,0,0-.36-1.36,3.9,3.9,0,0,0-3.16-2.32c-.44,0-.94,0-1.41,0l-5.7-.07-11.15-.12-21.25-.25-37.95-.45-54.43-.67-8.47-.11-3.39-.05a6.32,6.32,0,0,0-1.46.08,4,4,0,0,0-1.22.47,4.11,4.11,0,0,0-2,3A6,6,0,0,0,37.72,348.11Z",
    fill: "#263238",
    style: {
      transformOrigin: "144.723px 398.962px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "animable",
    cx: 118.29,
    cy: 396.86,
    r: 6.22,
    fill: "#fff",
    style: {
      transformOrigin: "118.29px 396.86px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "animable",
    d: "M37.9,349s.22,0,.65,0h9.22l26.93.13,88.85.62,12.85.11,3.16,0a8.1,8.1,0,0,1,1.61.1,4.5,4.5,0,0,1,3.44,3.21c.24,1,.41,2,.62,3l4.59,23.14c2.91,14.75,5.54,28,7.74,39.19s4,20.17,5.18,26.42c.6,3.11,1.06,5.53,1.38,7.19.15.81.27,1.44.35,1.88s.1.64.1.64-.06-.21-.15-.63-.23-1.06-.4-1.87L202.54,445c-1.26-6.25-3.08-15.26-5.34-26.39s-4.9-24.43-7.85-39.17c-1.47-7.37-3-15.11-4.62-23.13-.21-1-.39-2-.61-3a4,4,0,0,0-1.7-2.3,3.87,3.87,0,0,0-1.35-.54,7.45,7.45,0,0,0-1.52-.09l-3.15,0-12.85-.1-88.85-.78-26.93-.3L40.45,349l-1.91,0Z",
    fill: "#263238",
    style: {
      transformOrigin: "121.235px 401.815px"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/Course.a78ab2c730111f5e3cffb34a70af4a7d.svg";
export { ForwardRef as ReactComponent };